// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-inner-image-zoom/lib/styles.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/app-portal-pages.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%201200%20600%27%3E%3Crect%20width=%271200%27%20height=%27600%27%20fill=%27rgb%28251%2C247%2C239%29%27/%3E%3Cg%20opacity=%270.22%27%20fill=%27rgb%28214%2C203%2C184%29%27%3E%3Ccircle%20cx=%2796%27%20cy=%2786%27%20r=%276%27/%3E%3Ccircle%20cx=%27170%27%20cy=%27120%27%20r=%274%27/%3E%3Ccircle%20cx=%27110%27%20cy=%27180%27%20r=%275%27/%3E%3Ccircle%20cx=%271020%27%20cy=%2792%27%20r=%276%27/%3E%3Ccircle%20cx=%271090%27%20cy=%27140%27%20r=%274%27/%3E%3Ccircle%20cx=%271060%27%20cy=%27190%27%20r=%275%27/%3E%3Ccircle%20cx=%27120%27%20cy=%27520%27%20r=%276%27/%3E%3Ccircle%20cx=%27190%27%20cy=%27480%27%20r=%274%27/%3E%3Ccircle%20cx=%271080%27%20cy=%27520%27%20r=%276%27/%3E%3Ccircle%20cx=%271010%27%20cy=%27490%27%20r=%274%27/%3E%3C/g%3E%3Cpath%20d=%27M140%20105%20C250%2045%20370%2050%20480%20100%20C590%20150%20710%2050%20820%20100%20C930%20150%201055%2080%201060%20155%20C1070%20240%201075%20360%201055%20445%20C1035%20530%20910%20525%20810%20505%20C710%20485%20590%20560%20480%20510%20C370%20460%20245%20555%20165%20505%20C85%20455%2090%20400%20105%20325%20C120%20250%2065%20170%20140%20105%20Z%27%20fill=%27none%27%20stroke=%27rgb%28214%2C164%2C83%29%27%20stroke-width=%278%27%20opacity=%270.85%27/%3E%3Cpath%20d=%27M152%20118%20C258%2062%20372%2066%20476%20110%20C580%20154%20712%2066%20816%20110%20C920%20154%201038%2096%201044%20158%20C1055%20242%201058%20356%201040%20440%20C1022%20524%20902%20518%20808%20500%20C714%20482%20586%20546%20482%20502%20C378%20458%20258%20542%20174%20498%20C90%20454%2098%20402%20112%20328%20C126%20254%2082%20174%20152%20118%20Z%27%20fill=%27none%27%20stroke=%27rgb%28232%2C214%2C176%29%27%20stroke-width=%276%27%20opacity=%270.9%27/%3E%3Cg%20opacity=%270.92%27%3E%3Cg%20transform=%27translate%2870%2C40%29%27%3E%3Cg%20fill=%27rgb%28232%2C92%2C115%29%27%20opacity=%270.9%27%3E%3Ccircle%20cx=%2730%27%20cy=%2730%27%20r=%2710%27/%3E%3Ccircle%20cx=%2752%27%20cy=%2722%27%20r=%2710%27/%3E%3Ccircle%20cx=%2748%27%20cy=%2748%27%20r=%2710%27/%3E%3Ccircle%20cx=%2724%27%20cy=%2752%27%20r=%2710%27/%3E%3C/g%3E%3Ccircle%20cx=%2738%27%20cy=%2738%27%20r=%279%27%20fill=%27rgb%28246%2C197%2C93%29%27/%3E%3Cpath%20d=%27M10%2060%20C30%2046%2050%2046%2072%2060%27%20fill=%27none%27%20stroke=%27rgb%2893%2C121%2C100%29%27%20stroke-width=%276%27%20stroke-linecap=%27round%27/%3E%3C/g%3E%3Cg%20transform=%27translate%281020%2C55%29%27%3E%3Cg%20fill=%27rgb%28245%2C158%2C11%29%27%20opacity=%270.85%27%3E%3Ccircle%20cx=%2726%27%20cy=%2726%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2720%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2744%27%20r=%2710%27/%3E%3Ccircle%20cx=%2720%27%20cy=%2748%27%20r=%2710%27/%3E%3C/g%3E%3Ccircle%20cx=%2734%27%20cy=%2734%27%20r=%279%27%20fill=%27rgb%28250%2C204%2C21%29%27/%3E%3Cpath%20d=%27M8%2058%20C28%2046%2048%2046%2070%2058%27%20fill=%27none%27%20stroke=%27rgb%2893%2C121%2C100%29%27%20stroke-width=%276%27%20stroke-linecap=%27round%27/%3E%3C/g%3E%3Cg%20transform=%27translate%2878%2C500%29%27%3E%3Cg%20fill=%27rgb%28251%2C113%2C133%29%27%20opacity=%270.85%27%3E%3Ccircle%20cx=%2726%27%20cy=%2726%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2720%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2744%27%20r=%2710%27/%3E%3Ccircle%20cx=%2720%27%20cy=%2748%27%20r=%2710%27/%3E%3C/g%3E%3Ccircle%20cx=%2734%27%20cy=%2734%27%20r=%279%27%20fill=%27rgb%28246%2C197%2C93%29%27/%3E%3Cpath%20d=%27M8%2058%20C28%2046%2048%2046%2070%2058%27%20fill=%27none%27%20stroke=%27rgb%2893%2C121%2C100%29%27%20stroke-width=%276%27%20stroke-linecap=%27round%27/%3E%3C/g%3E%3Cg%20transform=%27translate%281030%2C498%29%27%3E%3Cg%20fill=%27rgb%28245%2C158%2C11%29%27%20opacity=%270.85%27%3E%3Ccircle%20cx=%2726%27%20cy=%2726%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2720%27%20r=%2710%27/%3E%3Ccircle%20cx=%2746%27%20cy=%2744%27%20r=%2710%27/%3E%3Ccircle%20cx=%2720%27%20cy=%2748%27%20r=%2710%27/%3E%3C/g%3E%3Ccircle%20cx=%2734%27%20cy=%2734%27%20r=%279%27%20fill=%27rgb%28250%2C204%2C21%29%27/%3E%3Cpath%20d=%27M8%2058%20C28%2046%2048%2046%2070%2058%27%20fill=%27none%27%20stroke=%27rgb%2893%2C121%2C100%29%27%20stroke-width=%276%27%20stroke-linecap=%27round%27/%3E%3C/g%3E%3C/g%3E%3Cg%20transform=%27translate%28300%2C300%29%27%20opacity=%270.95%27%3E%3Ccircle%20cx=%270%27%20cy=%270%27%20r=%27120%27%20fill=%27none%27%20stroke=%27rgb%2893%2C121%2C100%29%27%20stroke-width=%275%27/%3E%3Ccircle%20cx=%270%27%20cy=%270%27%20r=%27106%27%20fill=%27none%27%20stroke=%27rgb%28232%2C214%2C176%29%27%20stroke-width=%275%27/%3E%3Cg%20opacity=%270.9%27%3E%3Ccircle%20cx=%27-80%27%20cy=%27-10%27%20r=%275%27%20fill=%27rgb%28251%2C113%2C133%29%27/%3E%3Ccircle%20cx=%27-65%27%20cy=%2722%27%20r=%274%27%20fill=%27rgb%28251%2C113%2C133%29%27/%3E%3Ccircle%20cx=%27-92%27%20cy=%2718%27%20r=%273.5%27%20fill=%27rgb%28251%2C113%2C133%29%27/%3E%3Ccircle%20cx=%2778%27%20cy=%27-12%27%20r=%275%27%20fill=%27rgb%28245%2C158%2C11%29%27/%3E%3Ccircle%20cx=%2792%27%20cy=%2712%27%20r=%274%27%20fill=%27rgb%28245%2C158%2C11%29%27/%3E%3Ccircle%20cx=%2770%27%20cy=%2718%27%20r=%273.5%27%20fill=%27rgb%28245%2C158%2C11%29%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800&family=Great+Vibes&family=Playfair+Display:wght@400;500;600;700;800&family=Poppins:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root {
    /* White / black / blue portal theme */
    --primary-50: #eff6ff;
    --primary-100: #dbeafe;
    --primary-200: #bfdbfe;
    --primary-300: #93c5fd;
    --primary-400: #60a5fa;
    --primary-500: #2563eb;
    --primary-600: #1d4ed8;
    --primary-700: #1e40af;
    --primary-800: #1e3a8a;
    --primary-900: #172554;
    --primary-950: #0f172a;

    --om-paper: #ffffff;
    --om-surface: #ffffff;
    --om-ink: #0f172a;
    --om-ink-soft: #64748b;
    --om-ink-faint: #94a3b8;
    --om-accent: #2563eb;
    
    --gray-50: #ffffff;
    --gray-100: #f1f5f9;
    --gray-200: #e5e7eb;
    --gray-300: #d1d5db;
    --gray-400: #9ca3af;
    --gray-500: #6b7280;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --gray-800: #1f2937;
    --gray-900: #0f172a;
    --gray-950: #020617;
    --header-background: #ffffff;
    --header-border: 1px solid rgba(15, 23, 42, 0.08);
    --header-box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    --header-avatar-shadow: 0 2px 8px rgba(37, 99, 235, 0.12);
  }
html.dark {
    --header-background: #0f172a;
    --header-border: 1px solid rgba(255, 255, 255, 0.1);
    --header-box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
  }
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.btn-primary{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.btn-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.btn-secondary{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.btn-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.input-modern{
  width: 100%;
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  background-color: rgb(255 255 255 / 0.5);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.input-modern::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.input-modern:focus{
  border-color: transparent;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.input-modern:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
  background-color: rgb(30 41 59 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.input-modern:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.sidebar-item.active{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* PhotoBook backgrounds */
.photobook-bg-party {
    background: linear-gradient(135deg, rgba(250, 245, 255, 1) 0%, rgba(255, 255, 255, 1) 45%, rgba(240, 249, 255, 1) 100%);
  }
/* Wedding cover: matches provided sample (frame + florals + wreath) */
.photobook-bg-wedding-cover {
    background-color: rgb(251, 247, 239);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-x-2{
  left: 0.5rem;
  right: 0.5rem;
}
.inset-x-3{
  left: 0.75rem;
  right: 0.75rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-16{
  bottom: -4rem;
}
.-bottom-20{
  bottom: -5rem;
}
.-bottom-24{
  bottom: -6rem;
}
.-bottom-28{
  bottom: -7rem;
}
.-bottom-8{
  bottom: -2rem;
}
.-left-12{
  left: -3rem;
}
.-left-20{
  left: -5rem;
}
.-left-32{
  left: -8rem;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-12{
  right: -3rem;
}
.-right-16{
  right: -4rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-20{
  right: -5rem;
}
.-right-24{
  right: -6rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-40{
  right: -10rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-10{
  top: -2.5rem;
}
.-top-16{
  top: -4rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-20{
  top: -5rem;
}
.-top-24{
  top: -6rem;
}
.-top-3{
  top: -0.75rem;
}
.-top-32{
  top: -8rem;
}
.-top-4{
  top: -1rem;
}
.-top-40{
  top: -10rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[-80px\\]{
  bottom: -80px;
}
.bottom-\\[4\\%\\]{
  bottom: 4%;
}
.bottom-\\[5\\.5rem\\]{
  bottom: 5.5rem;
}
.bottom-\\[6\\%\\]{
  bottom: 6%;
}
.bottom-\\[72px\\]{
  bottom: 72px;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\.5{
  left: 0.375rem;
}
.left-1\\/2{
  left: 50%;
}
.left-1\\/3{
  left: 33.333333%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-6{
  left: 1.5rem;
}
.left-\\[-40px\\]{
  left: -40px;
}
.left-\\[4\\%\\]{
  left: 4%;
}
.left-\\[min\\(268px\\2c 37vw\\)\\]{
  left: min(268px, 37vw);
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-1\\/4{
  right: 25%;
}
.right-16{
  right: 4rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[-120px\\]{
  right: -120px;
}
.right-\\[10\\%\\]{
  right: 10%;
}
.right-\\[4\\%\\]{
  right: 4%;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-\\[4\\%\\]{
  top: 4%;
}
.top-\\[72px\\]{
  top: 72px;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100000\\]{
  z-index: 100000;
}
.z-\\[100001\\]{
  z-index: 100001;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[10001\\]{
  z-index: 10001;
}
.z-\\[10050\\]{
  z-index: 10050;
}
.z-\\[10\\]{
  z-index: 10;
}
.z-\\[11\\]{
  z-index: 11;
}
.z-\\[120\\]{
  z-index: 120;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[35\\]{
  z-index: 35;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[9998\\]{
  z-index: 9998;
}
.z-\\[99999\\]{
  z-index: 99999;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.order-first{
  order: -9999;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-full{
  grid-column: 1 / -1;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.-m-2{
  margin: -0.5rem;
}
.m-auto{
  margin: auto;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-28{
  margin-top: 7rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.\\!flex{
  display: flex !important;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[3\\/4\\]{
  aspect-ratio: 3/4;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[360px\\]{
  height: 360px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[50\\%\\]{
  height: 50%;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[54\\%\\]{
  height: 54%;
}
.h-\\[55\\%\\]{
  height: 55%;
}
.h-\\[58\\%\\]{
  height: 58%;
}
.h-\\[60\\%\\]{
  height: 60%;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[92px\\]{
  height: 92px;
}
.h-\\[92vh\\]{
  height: 92vh;
}
.h-\\[calc\\(100dvh-9rem\\)\\]{
  height: calc(100dvh - 9rem);
}
.h-\\[min\\(380px\\2c 52vh\\)\\]{
  height: min(380px, 52vh);
}
.h-\\[min\\(480px\\2c 50vw\\)\\]{
  height: min(480px, 50vw);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[100\\%\\]{
  max-height: 100%;
}
.max-h-\\[40vh\\]{
  max-height: 40vh;
}
.max-h-\\[45vh\\]{
  max-height: 45vh;
}
.max-h-\\[5\\.25rem\\]{
  max-height: 5.25rem;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[82vh\\]{
  max-height: 82vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(100dvh-10rem\\)\\]{
  max-height: calc(100dvh - 10rem);
}
.max-h-\\[calc\\(100dvh-8rem\\)\\]{
  max-height: calc(100dvh - 8rem);
}
.max-h-\\[calc\\(100dvh-9rem\\)\\]{
  max-height: calc(100dvh - 9rem);
}
.max-h-\\[min\\(360px\\2c 45vh\\)\\]{
  max-height: min(360px, 45vh);
}
.max-h-\\[min\\(42vh\\2c 280px\\)\\]{
  max-height: min(42vh, 280px);
}
.max-h-\\[min\\(55vh\\2c 420px\\)\\]{
  max-height: min(55vh, 420px);
}
.max-h-\\[min\\(85dvh\\2c 100\\%\\)\\]{
  max-height: min(85dvh, 100%);
}
.max-h-\\[min\\(90vh\\2c 720px\\)\\]{
  max-height: min(90vh, 720px);
}
.max-h-\\[min\\(92dvh\\2c 100\\%\\)\\]{
  max-height: min(92dvh, 100%);
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[110px\\]{
  min-height: 110px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[16rem\\]{
  min-height: 16rem;
}
.min-h-\\[2\\.75rem\\]{
  min-height: 2.75rem;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[40vh\\]{
  min-height: 40vh;
}
.min-h-\\[42vh\\]{
  min-height: 42vh;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[4rem\\]{
  min-height: 4rem;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[52px\\]{
  min-height: 52px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[88px\\]{
  min-height: 88px;
}
.min-h-\\[calc\\(100dvh-4\\.5rem\\)\\]{
  min-height: calc(100dvh - 4.5rem);
}
.min-h-\\[calc\\(100dvh-4rem\\)\\]{
  min-height: calc(100dvh - 4rem);
}
.min-h-\\[calc\\(100vh-4rem\\)\\]{
  min-height: calc(100vh - 4rem);
}
.min-h-\\[min\\(480px\\2c 50vh\\)\\]{
  min-height: min(480px, 50vh);
}
.min-h-\\[min\\(520px\\2c 55vh\\)\\]{
  min-height: min(520px, 55vh);
}
.min-h-\\[min\\(520px\\2c 65vh\\)\\]{
  min-height: min(520px, 65vh);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[290px\\]{
  width: 290px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[38\\%\\]{
  width: 38%;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[52\\%\\]{
  width: 52%;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[54\\%\\]{
  width: 54%;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[84\\%\\]{
  width: 84%;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[min\\(100\\%\\2c 20rem\\)\\]{
  width: min(100%, 20rem);
}
.w-\\[min\\(100\\%\\2c 24rem\\)\\]{
  width: min(100%, 24rem);
}
.w-\\[min\\(200px\\2c 38vw\\)\\]{
  width: min(200px, 38vw);
}
.w-\\[min\\(280px\\2c 38vw\\)\\]{
  width: min(280px, 38vw);
}
.w-\\[min\\(280px\\2c 88vw\\)\\]{
  width: min(280px, 88vw);
}
.w-\\[min\\(300px\\2c 80vw\\)\\]{
  width: min(300px, 80vw);
}
.w-\\[min\\(31rem\\2c calc\\(100vw-2rem\\)\\)\\]{
  width: min(31rem, calc(100vw - 2rem));
}
.w-\\[min\\(480px\\2c 50vw\\)\\]{
  width: min(480px, 50vw);
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[10rem\\]{
  min-width: 10rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[2\\.75rem\\]{
  min-width: 2.75rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[2rem\\]{
  min-width: 2rem;
}
.min-w-\\[36px\\]{
  min-width: 36px;
}
.min-w-\\[40px\\]{
  min-width: 40px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100\\%\\]{
  max-width: 100%;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[1280px\\]{
  max-width: 1280px;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[50\\%\\]{
  max-width: 50%;
}
.max-w-\\[50vw\\]{
  max-width: 50vw;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[58\\%\\]{
  max-width: 58%;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[7\\.5rem\\]{
  max-width: 7.5rem;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[85vw\\]{
  max-width: 85vw;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[90vw\\]{
  max-width: 90vw;
}
.max-w-\\[92\\%\\]{
  max-width: 92%;
}
.max-w-\\[95\\%\\]{
  max-width: 95%;
}
.max-w-\\[min\\(92\\%\\2c 20rem\\)\\]{
  max-width: min(92%, 20rem);
}
.max-w-\\[min\\(92\\%\\2c 26rem\\)\\]{
  max-width: min(92%, 26rem);
}
.max-w-\\[min\\(92\\%\\2c 280px\\)\\]{
  max-width: min(92%, 280px);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[1\\.5\\]{
  flex: 1.5 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.basis-0{
  flex-basis: 0px;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3{
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-3deg\\]{
  --tw-rotate: -3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[3deg\\]{
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.98\\]{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[progress_1\\.8s_ease-in-out_infinite\\]{
  animation: progress 1.8s ease-in-out infinite;
}
.animate-\\[slideDown_0\\.3s_ease-out\\]{
  animation: slideDown 0.3s ease-out;
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-crosshair{
  cursor: crosshair;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-grabbing{
  cursor: grabbing;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.cursor-zoom-out{
  cursor: zoom-out;
}
.touch-none{
  touch-action: none;
}
.touch-manipulation{
  touch-action: manipulation;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.break-inside-avoid{
  page-break-inside: avoid;
  break-inside: avoid;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-rows-2{
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-stretch{
  justify-content: stretch;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-stretch{
  align-self: stretch;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overscroll-y-contain{
  overscroll-behavior-y: contain;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[1\\.35rem\\]{
  border-radius: 1.35rem;
}
.rounded-\\[1\\.75rem\\]{
  border-radius: 1.75rem;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[16px\\]{
  border-radius: 16px;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[2rem\\]{
  border-radius: 2rem;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[3rem\\]{
  border-radius: 3rem;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-md{
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-4{
  border-right-width: 4px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#004ac6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 74 198 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0f172a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2731db\\]{
  --tw-border-opacity: 1;
  border-color: rgb(39 49 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4648d4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(70 72 212 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4648d4\\]\\/10{
  border-color: rgb(70 72 212 / 0.1);
}
.border-\\[\\#4648d4\\]\\/20{
  border-color: rgb(70 72 212 / 0.2);
}
.border-\\[\\#4648d4\\]\\/30{
  border-color: rgb(70 72 212 / 0.3);
}
.border-\\[\\#4648d4\\]\\/40{
  border-color: rgb(70 72 212 / 0.4);
}
.border-\\[\\#737686\\]{
  --tw-border-opacity: 1;
  border-color: rgb(115 118 134 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9E7FF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 231 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ba1a1a\\]\\/30{
  border-color: rgb(186 26 26 / 0.3);
}
.border-\\[\\#c3c6d7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(195 198 215 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe1ff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(219 225 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5e7eb\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#fde68a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ffffff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-\\[color\\:color-mix\\(in_oklab\\2c var\\(--border\\)\\2c transparent_25\\%\\)\\]{
  border-color: color-mix(in oklab,var(--border),transparent 25%);
}
.border-\\[color\\:color-mix\\(in_oklab\\2c var\\(--border\\)\\2c transparent_35\\%\\)\\]{
  border-color: color-mix(in oklab,var(--border),transparent 35%);
}
.border-\\[color\\:color-mix\\(in_oklab\\2c var\\(--border\\)\\2c transparent_45\\%\\)\\]{
  border-color: color-mix(in oklab,var(--border),transparent 45%);
}
.border-\\[color\\:color-mix\\(in_oklab\\2c var\\(--border\\)\\2c transparent_50\\%\\)\\]{
  border-color: color-mix(in oklab,var(--border),transparent 50%);
}
.border-\\[color\\:var\\(--ff-border\\)\\]{
  border-color: var(--ff-border);
}
.border-\\[color\\:var\\(--input\\)\\]{
  border-color: var(--input);
}
.border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.08\\)\\]{
  border-color: rgba(20,18,16,0.08);
}
.border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.1\\)\\]{
  border-color: rgba(20,18,16,0.1);
}
.border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.12\\)\\]{
  border-color: rgba(20,18,16,0.12);
}
.border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.14\\)\\]{
  border-color: rgba(20,18,16,0.14);
}
.border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.16\\)\\]{
  border-color: rgba(20,18,16,0.16);
}
.border-\\[rgba\\(31\\2c 58\\2c 52\\2c 0\\.2\\)\\]{
  border-color: rgba(31,58,52,0.2);
}
.border-\\[var\\(--header-border\\)\\]{
  border-color: var(--header-border);
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/50{
  border-color: rgb(253 230 138 / 0.5);
}
.border-amber-200\\/80{
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-200\\/90{
  border-color: rgb(253 230 138 / 0.9);
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/60{
  border-color: rgb(251 191 36 / 0.6);
}
.border-amber-500\\/25{
  border-color: rgb(245 158 11 / 0.25);
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-800\\/30{
  border-color: rgb(146 64 14 / 0.3);
}
.border-black\\/25{
  border-color: rgb(0 0 0 / 0.25);
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-100\\/50{
  border-color: rgb(219 234 254 / 0.5);
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/50{
  border-color: rgb(191 219 254 / 0.5);
}
.border-blue-200\\/70{
  border-color: rgb(191 219 254 / 0.7);
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/60{
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-100\\/50{
  border-color: rgb(220 252 231 / 0.5);
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/50{
  border-color: rgb(224 231 255 / 0.5);
}
.border-indigo-100\\/80{
  border-color: rgb(224 231 255 / 0.8);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/60{
  border-color: rgb(199 210 254 / 0.6);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/50{
  border-color: rgb(99 102 241 / 0.5);
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-pink-100{
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity, 1));
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-100\\/50{
  border-color: rgb(243 232 255 / 0.5);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-100\\/50{
  border-color: rgb(254 226 226 / 0.5);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-400\\/70{
  border-color: rgb(251 113 133 / 0.7);
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-400{
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-100\\/80{
  border-color: rgb(241 245 249 / 0.8);
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/40{
  border-color: rgb(226 232 240 / 0.4);
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-200\\/90{
  border-color: rgb(226 232 240 / 0.9);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/50{
  border-color: rgb(51 65 85 / 0.5);
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-100\\/80{
  border-color: rgb(237 233 254 / 0.8);
}
.border-violet-200\\/60{
  border-color: rgb(221 214 254 / 0.6);
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/40{
  border-color: rgb(139 92 246 / 0.4);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/35{
  border-color: rgb(255 255 255 / 0.35);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60{
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}
.border-white\\/80{
  border-color: rgb(255 255 255 / 0.8);
}
.border-white\\/90{
  border-color: rgb(255 255 255 / 0.9);
}
.border-white\\/\\[0\\.06\\]{
  border-color: rgb(255 255 255 / 0.06);
}
.border-white\\/\\[0\\.08\\]{
  border-color: rgb(255 255 255 / 0.08);
}
.border-yellow-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity, 1));
}
.border-yellow-100\\/50{
  border-color: rgb(254 249 195 / 0.5);
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#004ac6\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(0 74 198 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#2731db\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(39 49 219 / var(--tw-border-opacity, 1));
}
.border-t-gray-900{
  --tw-border-opacity: 1;
  border-top-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-t-slate-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.border-t-slate-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-violet-300{
  --tw-border-opacity: 1;
  border-top-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-t-violet-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#004ac6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 74 198 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#050508\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(5 5 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#060508\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(6 5 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#07070a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(7 7 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b0b12\\]\\/95{
  background-color: rgb(11 11 18 / 0.95);
}
.bg-\\[\\#0f172a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\]\\/40{
  background-color: rgb(15 23 42 / 0.4);
}
.bg-\\[\\#111827\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#14141d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 29 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563eb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2731db\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(39 49 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2731db\\]\\/10{
  background-color: rgb(39 49 219 / 0.1);
}
.bg-\\[\\#4648d4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(70 72 212 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4648d4\\]\\/10{
  background-color: rgb(70 72 212 / 0.1);
}
.bg-\\[\\#4648d4\\]\\/20{
  background-color: rgb(70 72 212 / 0.2);
}
.bg-\\[\\#4648d4\\]\\/5{
  background-color: rgb(70 72 212 / 0.05);
}
.bg-\\[\\#8127cf\\]\\/10{
  background-color: rgb(129 39 207 / 0.1);
}
.bg-\\[\\#ba1a1a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(186 26 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d0e1fb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(208 225 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d0e1fb\\]\\/30{
  background-color: rgb(208 225 251 / 0.3);
}
.bg-\\[\\#d0e1fb\\]\\/50{
  background-color: rgb(208 225 251 / 0.5);
}
.bg-\\[\\#dbe1ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(219 225 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dbe1ff\\]\\/30{
  background-color: rgb(219 225 255 / 0.3);
}
.bg-\\[\\#e2e8f0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7e7f3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 231 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ec4899\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eceef0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 238 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff6ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f5f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fffbeb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff\\]\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-\\[\\#ffffff\\]\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-\\[color\\:color-mix\\(in_oklab\\2c var\\(--foreground\\)\\2c transparent_55\\%\\)\\]{
  background-color: color-mix(in oklab,var(--foreground),transparent 55%);
}
.bg-\\[color\\:color-mix\\(in_oklab\\2c var\\(--primary\\)\\2c transparent_90\\%\\)\\]{
  background-color: color-mix(in oklab,var(--primary),transparent 90%);
}
.bg-\\[color\\:color-mix\\(in_oklab\\2c var\\(--secondary\\)\\2c transparent_60\\%\\)\\]{
  background-color: color-mix(in oklab,var(--secondary),transparent 60%);
}
.bg-\\[color\\:var\\(--ff-bg\\)\\]{
  background-color: var(--ff-bg);
}
.bg-\\[color\\:var\\(--ff-primary-soft\\)\\]{
  background-color: var(--ff-primary-soft);
}
.bg-\\[oklch\\(0\\.12_0\\.02_270\\/0\\.97\\)\\]{
  background-color: oklch(0.12 0.02 270/0.97);
}
.bg-\\[rgba\\(247\\2c 246\\2c 243\\2c 0\\.9\\)\\]{
  background-color: rgba(247,246,243,0.9);
}
.bg-\\[var\\(--background\\)\\]{
  background-color: var(--background);
}
.bg-\\[var\\(--card\\)\\]{
  background-color: var(--card);
}
.bg-\\[var\\(--header-background\\)\\]{
  background-color: var(--header-background);
}
.bg-\\[var\\(--secondary\\)\\]{
  background-color: var(--secondary);
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200\\/90{
  background-color: rgb(253 230 138 / 0.9);
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/50{
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/80{
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-50\\/90{
  background-color: rgb(255 251 235 / 0.9);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-500\\/\\[0\\.08\\]{
  background-color: rgb(245 158 11 / 0.08);
}
.bg-amber-600\\/80{
  background-color: rgb(217 119 6 / 0.8);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/15{
  background-color: rgb(0 0 0 / 0.15);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/25{
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/35{
  background-color: rgb(0 0 0 / 0.35);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-black\\/95{
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300\\/25{
  background-color: rgb(147 197 253 / 0.25);
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-400\\/15{
  background-color: rgb(96 165 250 / 0.15);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-50\\/80{
  background-color: rgb(239 246 255 / 0.8);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/80{
  background-color: rgb(236 253 245 / 0.8);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/80{
  background-color: rgb(5 150 105 / 0.8);
}
.bg-fuchsia-200\\/35{
  background-color: rgb(245 208 254 / 0.35);
}
.bg-fuchsia-500\\/15{
  background-color: rgb(217 70 239 / 0.15);
}
.bg-fuchsia-500\\/\\[0\\.10\\]{
  background-color: rgb(217 70 239 / 0.10);
}
.bg-fuchsia-600\\/15{
  background-color: rgb(192 38 211 / 0.15);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/20{
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-500\\/80{
  background-color: rgb(34 197 94 / 0.8);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200\\/80{
  background-color: rgb(199 210 254 / 0.8);
}
.bg-indigo-200\\/90{
  background-color: rgb(199 210 254 / 0.9);
}
.bg-indigo-300\\/15{
  background-color: rgb(165 180 252 / 0.15);
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400\\/10{
  background-color: rgb(129 140 248 / 0.1);
}
.bg-indigo-400\\/\\[0\\.06\\]{
  background-color: rgb(129 140 248 / 0.06);
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/60{
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-50\\/80{
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-50\\/95{
  background-color: rgb(238 242 255 / 0.95);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10{
  background-color: rgb(99 102 241 / 0.1);
}
.bg-indigo-500\\/30{
  background-color: rgb(99 102 241 / 0.3);
}
.bg-indigo-500\\/\\[0\\.03\\]{
  background-color: rgb(99 102 241 / 0.03);
}
.bg-indigo-500\\/\\[0\\.04\\]{
  background-color: rgb(99 102 241 / 0.04);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600\\/80{
  background-color: rgb(79 70 229 / 0.8);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-primary-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-primary-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/20{
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-500\\/80{
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/80{
  background-color: rgb(255 241 242 / 0.8);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/25{
  background-color: rgb(244 63 94 / 0.25);
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/80{
  background-color: rgb(226 232 240 / 0.8);
}
.bg-slate-200\\/90{
  background-color: rgb(226 232 240 / 0.9);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-300\\/40{
  background-color: rgb(203 213 225 / 0.4);
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-50\\/90{
  background-color: rgb(248 250 252 / 0.9);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-600\\/20{
  background-color: rgb(71 85 105 / 0.2);
}
.bg-slate-600\\/80{
  background-color: rgb(71 85 105 / 0.8);
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/5{
  background-color: rgb(15 23 42 / 0.05);
}
.bg-slate-900\\/50{
  background-color: rgb(15 23 42 / 0.5);
}
.bg-slate-900\\/55{
  background-color: rgb(15 23 42 / 0.55);
}
.bg-slate-900\\/60{
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-950\\/80{
  background-color: rgb(2 6 23 / 0.8);
}
.bg-stone-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-200\\/40{
  background-color: rgb(221 214 254 / 0.4);
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-violet-400\\/30{
  background-color: rgb(167 139 250 / 0.3);
}
.bg-violet-400\\/50{
  background-color: rgb(167 139 250 / 0.5);
}
.bg-violet-400\\/70{
  background-color: rgb(167 139 250 / 0.7);
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/80{
  background-color: rgb(245 243 255 / 0.8);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-500\\/\\[0\\.12\\]{
  background-color: rgb(139 92 246 / 0.12);
}
.bg-violet-600\\/15{
  background-color: rgb(124 58 237 / 0.15);
}
.bg-violet-600\\/20{
  background-color: rgb(124 58 237 / 0.2);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75{
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.05\\]{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-white\\/\\[0\\.07\\]{
  background-color: rgb(255 255 255 / 0.07);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-opacity-0{
  --tw-bg-opacity: 0;
}
.bg-opacity-20{
  --tw-bg-opacity: 0.2;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-opacity-95{
  --tw-bg-opacity: 0.95;
}
.bg-\\[radial-gradient\\(circle_at_center\\2c \\#4648d4\\2c transparent_70\\%\\)\\]{
  background-image: radial-gradient(circle at center,#4648d4,transparent 70%);
}
.bg-\\[radial-gradient\\(circle_at_top_left\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.35\\)\\2c transparent_35\\%\\)\\2c radial-gradient\\(circle_at_bottom_right\\2c rgba\\(99\\2c 102\\2c 241\\2c 0\\.25\\)\\2c transparent_35\\%\\)\\]{
  background-image: radial-gradient(circle at top left,rgba(255,255,255,0.35),transparent 35%),radial-gradient(circle at bottom right,rgba(99,102,241,0.25),transparent 35%);
}
.bg-\\[radial-gradient\\(ellipse_80\\%_50\\%_at_50\\%_-20\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.15\\)\\2c transparent\\)\\]{
  background-image: radial-gradient(ellipse 80% 50% at 50% -20%,rgba(255,255,255,0.15),transparent);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#060508\\]{
  --tw-gradient-from: #060508 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 5 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#060508\\]\\/90{
  --tw-gradient-from: rgb(6 5 8 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 5 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#06b6d4\\]{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0f0f14\\]{
  --tw-gradient-from: #0f0f14 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 15 20 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2731db\\]{
  --tw-gradient-from: #2731db var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(39 49 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#4648d4\\]{
  --tw-gradient-from: #4648d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(70 72 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#513cd2\\]{
  --tw-gradient-from: #513cd2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(81 60 210 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#8b5cf6\\]{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ec4899\\]{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ede9fe\\]{
  --tw-gradient-from: #ede9fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 233 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ef4444\\]{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/50{
  --tw-gradient-from: rgb(255 251 235 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600{
  --tw-gradient-from: #d97706 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/50{
  --tw-gradient-from: rgb(0 0 0 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/55{
  --tw-gradient-from: rgb(0 0 0 / 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/60{
  --tw-gradient-from: rgb(0 0 0 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/65{
  --tw-gradient-from: rgb(0 0 0 / 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70{
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80{
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/85{
  --tw-gradient-from: rgb(0 0 0 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100{
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400{
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/40{
  --tw-gradient-from: rgb(239 246 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/50{
  --tw-gradient-from: rgb(239 246 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-700{
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50{
  --tw-gradient-from: #ecfeff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400{
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-500{
  --tw-gradient-from: #d946ef var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 70 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-100{
  --tw-gradient-from: #f3f4f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 244 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-300{
  --tw-gradient-from: #d1d5db var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-400{
  --tw-gradient-from: #9ca3af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 163 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50{
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-500{
  --tw-gradient-from: #6b7280 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600{
  --tw-gradient-from: #4b5563 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(75 85 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-100{
  --tw-gradient-from: #dcfce7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 252 231 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400{
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50{
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100{
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/50{
  --tw-gradient-from: rgb(238 242 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80{
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900{
  --tw-gradient-from: #312e81 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50{
  --tw-gradient-from: #fdf2f8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100{
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400{
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-100{
  --tw-gradient-from: #fee2e2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 226 226 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400{
  --tw-gradient-from: #f87171 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-50{
  --tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600{
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500{
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400{
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-50{
  --tw-gradient-from: #f0f9ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200{
  --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200\\/90{
  --tw-gradient-from: rgb(226 232 240 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50\\/50{
  --tw-gradient-from: rgb(248 250 252 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50\\/80{
  --tw-gradient-from: rgb(248 250 252 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-500{
  --tw-gradient-from: #64748b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-600{
  --tw-gradient-from: #475569 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-700{
  --tw-gradient-from: #334155 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-800{
  --tw-gradient-from: #1e293b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 41 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-950{
  --tw-gradient-from: #020617 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500{
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-100{
  --tw-gradient-from: #ede9fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 233 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-200{
  --tw-gradient-from: #ddd6fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(221 214 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400{
  --tw-gradient-from: #a78bfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50{
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/10{
  --tw-gradient-from: rgb(139 92 246 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/\\[0\\.07\\]{
  --tw-gradient-from: rgb(255 255 255 / 0.07) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400{
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500{
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#16161d\\]{
  --tw-gradient-to: rgb(22 22 29 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #16161d var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#4648d4\\]{
  --tw-gradient-to: rgb(70 72 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4648d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#f0ebff\\]{
  --tw-gradient-to: rgb(240 235 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f0ebff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/10{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/25{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-400{
  --tw-gradient-to: rgb(96 165 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #60a5fa var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-50{
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #eff6ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-50\\/20{
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(239 246 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-50\\/30{
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(239 246 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500{
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3b82f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-600{
  --tw-gradient-to: rgb(37 99 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2563eb var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500{
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-500{
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-600{
  --tw-gradient-to: rgb(5 150 105 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #059669 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-fuchsia-600{
  --tw-gradient-to: rgb(192 38 211 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #c026d3 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-50{
  --tw-gradient-to: rgb(249 250 251 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f9fafb var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-500{
  --tw-gradient-to: rgb(107 114 128 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6b7280 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-50\\/30{
  --tw-gradient-to: rgb(240 253 244 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 253 244 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500{
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6366f1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-600{
  --tw-gradient-to: rgb(79 70 229 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4f46e5 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-950{
  --tw-gradient-to: rgb(30 27 75 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e1b4b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-500{
  --tw-gradient-to: rgb(249 115 22 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f97316 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-600{
  --tw-gradient-to: rgb(234 88 12 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ea580c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50\\/30{
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(250 245 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600{
  --tw-gradient-to: rgb(147 51 234 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9333ea var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-900{
  --tw-gradient-to: rgb(88 28 135 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #581c87 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-50\\/30{
  --tw-gradient-to: rgb(254 242 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(254 242 242 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-50{
  --tw-gradient-to: rgb(255 241 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff1f2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-500{
  --tw-gradient-to: rgb(244 63 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f43f5e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-100{
  --tw-gradient-to: rgb(241 245 249 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f1f5f9 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-200{
  --tw-gradient-to: rgb(226 232 240 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #e2e8f0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-300{
  --tw-gradient-to: rgb(203 213 225 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #cbd5e1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-600{
  --tw-gradient-to: rgb(71 85 105 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #475569 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-700{
  --tw-gradient-to: rgb(51 65 85 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #334155 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-400\\/50{
  --tw-gradient-to: rgb(167 139 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(167 139 250 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-500\\/60{
  --tw-gradient-to: rgb(139 92 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(139 92 246 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/20{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-yellow-50\\/30{
  --tw-gradient-to: rgb(254 252 232 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(254 252 232 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#050508\\]{
  --tw-gradient-to: #050508 var(--tw-gradient-to-position);
}
.to-\\[\\#1a1a24\\]{
  --tw-gradient-to: #1a1a24 var(--tw-gradient-to-position);
}
.to-\\[\\#6366f1\\]{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-\\[\\#8127cf\\]{
  --tw-gradient-to: #8127cf var(--tw-gradient-to-position);
}
.to-\\[\\#8b5cf6\\]{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-\\[\\#ec4899\\]{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-\\[\\#f43f5e\\]{
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-\\[\\#f8f5ff\\]{
  --tw-gradient-to: #f8f5ff var(--tw-gradient-to-position);
}
.to-amber-100\\/80{
  --tw-gradient-to: rgb(254 243 199 / 0.8) var(--tw-gradient-to-position);
}
.to-amber-600{
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-amber-700{
  --tw-gradient-to: #b45309 var(--tw-gradient-to-position);
}
.to-black\\/20{
  --tw-gradient-to: rgb(0 0 0 / 0.2) var(--tw-gradient-to-position);
}
.to-blue-100{
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}
.to-blue-50{
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-blue-500{
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-50{
  --tw-gradient-to: #ecfeff var(--tw-gradient-to-position);
}
.to-emerald-100{
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-50{
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-50\\/30{
  --tw-gradient-to: rgb(236 253 245 / 0.3) var(--tw-gradient-to-position);
}
.to-emerald-500{
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-emerald-700{
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}
.to-fuchsia-100{
  --tw-gradient-to: #fae8ff var(--tw-gradient-to-position);
}
.to-fuchsia-200{
  --tw-gradient-to: #f5d0fe var(--tw-gradient-to-position);
}
.to-fuchsia-400{
  --tw-gradient-to: #e879f9 var(--tw-gradient-to-position);
}
.to-fuchsia-50{
  --tw-gradient-to: #fdf4ff var(--tw-gradient-to-position);
}
.to-fuchsia-500{
  --tw-gradient-to: #d946ef var(--tw-gradient-to-position);
}
.to-fuchsia-500\\/10{
  --tw-gradient-to: rgb(217 70 239 / 0.1) var(--tw-gradient-to-position);
}
.to-fuchsia-600{
  --tw-gradient-to: #c026d3 var(--tw-gradient-to-position);
}
.to-gray-100{
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-gray-200{
  --tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);
}
.to-gray-400{
  --tw-gradient-to: #9ca3af var(--tw-gradient-to-position);
}
.to-gray-500{
  --tw-gradient-to: #6b7280 var(--tw-gradient-to-position);
}
.to-gray-600{
  --tw-gradient-to: #4b5563 var(--tw-gradient-to-position);
}
.to-gray-700{
  --tw-gradient-to: #374151 var(--tw-gradient-to-position);
}
.to-green-600{
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-indigo-100{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-400{
  --tw-gradient-to: #818cf8 var(--tw-gradient-to-position);
}
.to-indigo-50{
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/30{
  --tw-gradient-to: rgb(238 242 255 / 0.3) var(--tw-gradient-to-position);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-orange-50{
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-50\\/30{
  --tw-gradient-to: rgb(255 247 237 / 0.3) var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-orange-700{
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}
.to-pink-100{
  --tw-gradient-to: #fce7f3 var(--tw-gradient-to-position);
}
.to-pink-50{
  --tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);
}
.to-pink-50\\/30{
  --tw-gradient-to: rgb(253 242 248 / 0.3) var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-600{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-pink-900{
  --tw-gradient-to: #831843 var(--tw-gradient-to-position);
}
.to-primary-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-purple-100{
  --tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);
}
.to-purple-50{
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/20{
  --tw-gradient-to: rgb(250 245 255 / 0.2) var(--tw-gradient-to-position);
}
.to-purple-50\\/30{
  --tw-gradient-to: rgb(250 245 255 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-50\\/50{
  --tw-gradient-to: rgb(250 245 255 / 0.5) var(--tw-gradient-to-position);
}
.to-purple-500{
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-700{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-red-100{
  --tw-gradient-to: #fee2e2 var(--tw-gradient-to-position);
}
.to-red-500{
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-rose-50{
  --tw-gradient-to: #fff1f2 var(--tw-gradient-to-position);
}
.to-rose-500{
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-sky-500{
  --tw-gradient-to: #0ea5e9 var(--tw-gradient-to-position);
}
.to-slate-200{
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-300\\/80{
  --tw-gradient-to: rgb(203 213 225 / 0.8) var(--tw-gradient-to-position);
}
.to-slate-400{
  --tw-gradient-to: #94a3b8 var(--tw-gradient-to-position);
}
.to-slate-600{
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}
.to-slate-700{
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.to-slate-800{
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-slate-900{
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-50{
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-500{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-violet-950{
  --tw-gradient-to: #2e1065 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-white\\/\\[0\\.02\\]{
  --tw-gradient-to: rgb(255 255 255 / 0.02) var(--tw-gradient-to-position);
}
.to-yellow-500{
  --tw-gradient-to: #eab308 var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-white{
  fill: #fff;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.\\!p-5{
  padding: 1.25rem !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[3px\\]{
  padding: 3px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-28{
  padding-bottom: 7rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-\\[max\\(1rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-20{
  padding-right: 5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[4\\.5rem\\]{
  padding-top: 4.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.font-\\[\\'Playfair_Display\\'\\]{
  font-family: 'Playfair Display';
}
.font-\\[family-name\\:var\\(--om-auth-display\\)\\]{
  font-family: var(--om-auth-display);
}
.font-memories-body{
  font-family: Outfit, ui-sans-serif, system-ui, sans-serif;
}
.font-memories-display{
  font-family: "Cormorant Garamond", Georgia, Cambria, Times New Roman, serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-serif{
  font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl{
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[1\\.25rem\\]{
  font-size: 1.25rem;
}
.text-\\[1\\.35rem\\]{
  font-size: 1.35rem;
}
.text-\\[1\\.45rem\\]{
  font-size: 1.45rem;
}
.text-\\[1\\.85rem\\]{
  font-size: 1.85rem;
}
.text-\\[1\\.875rem\\]{
  font-size: 1.875rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[2\\.35rem\\]{
  font-size: 2.35rem;
}
.text-\\[2\\.65rem\\]{
  font-size: 2.65rem;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[2rem\\]{
  font-size: 2rem;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.08\\]{
  line-height: 1.08;
}
.leading-\\[1\\.12\\]{
  line-height: 1.12;
}
.leading-\\[1\\.15\\]{
  line-height: 1.15;
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\]{
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.03em\\]{
  letter-spacing: -0.03em;
}
.tracking-\\[0\\.06em\\]{
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.28em\\]{
  letter-spacing: 0.28em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.35em\\]{
  letter-spacing: 0.35em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#004ac6\\]{
  --tw-text-opacity: 1;
  color: rgb(0 74 198 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0b1c30\\]{
  --tw-text-opacity: 1;
  color: rgb(11 28 48 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f172a\\]{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#191b23\\]{
  --tw-text-opacity: 1;
  color: rgb(25 27 35 / var(--tw-text-opacity, 1));
}
.text-\\[\\#191c1e\\]{
  --tw-text-opacity: 1;
  color: rgb(25 28 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2563eb\\]{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2731db\\]{
  --tw-text-opacity: 1;
  color: rgb(39 49 219 / var(--tw-text-opacity, 1));
}
.text-\\[\\#464554\\]{
  --tw-text-opacity: 1;
  color: rgb(70 69 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4648d4\\]{
  --tw-text-opacity: 1;
  color: rgb(70 72 212 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4a4455\\]{
  --tw-text-opacity: 1;
  color: rgb(74 68 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4a4455\\]\\/60{
  color: rgb(74 68 85 / 0.6);
}
.text-\\[\\#505f76\\]{
  --tw-text-opacity: 1;
  color: rgb(80 95 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#513cd2\\]{
  --tw-text-opacity: 1;
  color: rgb(81 60 210 / var(--tw-text-opacity, 1));
}
.text-\\[\\#630ed4\\]{
  --tw-text-opacity: 1;
  color: rgb(99 14 212 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64748b\\]{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#737686\\]{
  --tw-text-opacity: 1;
  color: rgb(115 118 134 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7b7487\\]{
  --tw-text-opacity: 1;
  color: rgb(123 116 135 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8127cf\\]{
  --tw-text-opacity: 1;
  color: rgb(129 39 207 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a5a2b\\]{
  --tw-text-opacity: 1;
  color: rgb(138 90 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#92400e\\]{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-\\[\\#943700\\]{
  --tw-text-opacity: 1;
  color: rgb(148 55 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#94a3b8\\]{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ba1a1a\\]{
  --tw-text-opacity: 1;
  color: rgb(186 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e2e8f0\\]{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ffffff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ffffff\\]\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-\\[color\\:var\\(--ff-muted\\)\\]{
  color: var(--ff-muted);
}
.text-\\[color\\:var\\(--ff-on-surface\\)\\]{
  color: var(--ff-on-surface);
}
.text-\\[color\\:var\\(--ff-primary\\)\\]{
  color: var(--ff-primary);
}
.text-\\[color\\:var\\(--foreground\\)\\]{
  color: var(--foreground);
}
.text-\\[color\\:var\\(--header-background\\)\\]{
  color: var(--header-background);
}
.text-\\[color\\:var\\(--muted-foreground\\)\\]{
  color: var(--muted-foreground);
}
.text-\\[color\\:var\\(--primary\\)\\]{
  color: var(--primary);
}
.text-\\[color\\:var\\(--primary-foreground\\)\\]{
  color: var(--primary-foreground);
}
.text-\\[color\\:var\\(--secondary-foreground\\)\\]{
  color: var(--secondary-foreground);
}
.text-amber-100{
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-amber-100\\/90{
  color: rgb(254 243 199 / 0.9);
}
.text-amber-200\\/90{
  color: rgb(253 230 138 / 0.9);
}
.text-amber-200\\/95{
  color: rgb(253 230 138 / 0.95);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-300\\/70{
  color: rgb(252 211 77 / 0.7);
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-blue-950{
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity, 1));
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-fuchsia-500{
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-100{
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-indigo-950{
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity, 1));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-pink-300{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.text-pink-400{
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-pink-900{
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity, 1));
}
.text-primary-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-primary-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-purple-300{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-300{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-950{
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-200\\/70{
  color: rgb(226 232 240 / 0.7);
}
.text-slate-200\\/80{
  color: rgb(226 232 240 / 0.8);
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-300\\/80{
  color: rgb(203 213 225 / 0.8);
}
.text-slate-300\\/90{
  color: rgb(203 213 225 / 0.9);
}
.text-slate-300\\/95{
  color: rgb(203 213 225 / 0.95);
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-400\\/80{
  color: rgb(148 163 184 / 0.8);
}
.text-slate-400\\/95{
  color: rgb(148 163 184 / 0.95);
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-slate-950{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.text-stone-800{
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-100{
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity, 1));
}
.text-violet-200{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}
.text-violet-200\\/90{
  color: rgb(221 214 254 / 0.9);
}
.text-violet-200\\/95{
  color: rgb(221 214 254 / 0.95);
}
.text-violet-300{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-violet-300\\/80{
  color: rgb(196 181 253 / 0.8);
}
.text-violet-300\\/85{
  color: rgb(196 181 253 / 0.85);
}
.text-violet-300\\/90{
  color: rgb(196 181 253 / 0.9);
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-400\\/90{
  color: rgb(167 139 250 / 0.9);
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-violet-950{
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/20{
  color: rgb(255 255 255 / 0.2);
}
.text-white\\/25{
  color: rgb(255 255 255 / 0.25);
}
.text-white\\/30{
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/35{
  color: rgb(255 255 255 / 0.35);
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/45{
  color: rgb(255 255 255 / 0.45);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-white\\/95{
  color: rgb(255 255 255 / 0.95);
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.no-underline{
  text-decoration-line: none;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.accent-cyan-500{
  accent-color: #06b6d4;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-95{
  opacity: 0.95;
}
.opacity-\\[0\\.12\\]{
  opacity: 0.12;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 -4px 12px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 -4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 -4px 24px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 -4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\2c 0_25px_60px_-12px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(0,0,0,0.05),0 25px 60px -12px rgba(15,23,42,0.25);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color), 0 25px 60px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 0 12px rgba(16,185,129,0.6);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 0 8px rgba(16,185,129,0.5);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_20px_-5px_rgba\\(70\\2c 72\\2c 212\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 10px 20px -5px rgba(70,72,212,0.4);
  --tw-shadow-colored: 0 10px 20px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(20\\2c 18\\2c 16\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 12px 32px rgba(20,18,16,0.05);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_-8px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 12px 40px -8px rgba(124,58,237,0.55);
  --tw-shadow-colored: 0 12px 40px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 12px 40px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(20\\2c 18\\2c 16\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 16px 40px rgba(20,18,16,0.06);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(20\\2c 18\\2c 16\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 16px 40px rgba(20,18,16,0.08);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 16px 48px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 16px 48px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 18px 60px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 18px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 20px 50px -20px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 20px 50px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(91\\2c 33\\2c 182\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 20px 60px rgba(91,33,182,0.08);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_70px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 20px 70px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 20px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-40px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 24px 60px -40px rgba(124,58,237,0.35);
  --tw-shadow-colored: 0 24px 60px -40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\]{
  --tw-shadow: 0 24px 80px rgba(0,0,0,0.65);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)\\]{
  --tw-shadow: 0 24px 80px rgba(0,0,0,0.7);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_80px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 24px 80px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_50px_-12px_rgba\\(70\\2c 72\\2c 212\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 25px 50px -12px rgba(70,72,212,0.4);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_90px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\2c inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 28px 90px rgba(0,0,0,0.55),inset 0 1px 0 rgba(255,255,255,0.12);
  --tw-shadow-colored: 0 28px 90px var(--tw-shadow-color), inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_-2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 2px 8px -2px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 2px 8px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_100px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 30px 100px rgba(0,0,0,0.6);
  --tw-shadow-colored: 0 30px 100px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_-2px_rgba\\(79\\2c 70\\2c 229\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 4px 12px -2px rgba(79,70,229,0.5);
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 4px 14px rgba(15,23,42,0.18);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 4px 14px rgba(37,99,235,0.18);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 4px 20px rgba(37,99,235,0.05);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 4px 24px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(20\\2c 18\\2c 16\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 4px 24px rgba(20,18,16,0.04);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_16px_-8px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 6px 16px -8px rgba(37,99,235,0.55);
  --tw-shadow-colored: 0 6px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(39\\2c 49\\2c 219\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 20px rgba(39,49,219,0.28);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 74\\2c 198\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 8px 24px rgba(0,74,198,0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 8px 30px rgba(37,99,235,0.06);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0_32px_rgba\\(20\\2c 18\\2c 16\\2c 0\\.08\\)\\]{
  --tw-shadow: 4px 0 32px rgba(20,18,16,0.08);
  --tw-shadow-colored: 4px 0 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#4648d4\\]\\/20{
  --tw-shadow-color: rgb(70 72 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[\\#4648d4\\]\\/25{
  --tw-shadow-color: rgb(70 72 212 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--header-box-shadow\\)\\]{
  --tw-shadow-color: var(--header-box-shadow);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/40{
  --tw-shadow-color: rgb(0 0 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/50{
  --tw-shadow-color: rgb(52 211 153 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/30{
  --tw-shadow-color: rgb(5 150 105 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200{
  --tw-shadow-color: #c7d2fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/25{
  --tw-shadow-color: rgb(99 102 241 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/30{
  --tw-shadow-color: rgb(99 102 241 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20{
  --tw-shadow-color: rgb(249 115 22 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-600\\/30{
  --tw-shadow-color: rgb(220 38 38 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-900\\/15{
  --tw-shadow-color: rgb(15 23 42 / 0.15);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/20{
  --tw-shadow-color: rgb(139 92 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/25{
  --tw-shadow-color: rgb(139 92 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/30{
  --tw-shadow-color: rgb(139 92 246 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-600\\/25{
  --tw-shadow-color: rgb(124 58 237 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-900\\/40{
  --tw-shadow-color: rgb(76 29 149 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#2731db\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(39 49 219 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#4648d4\\]\\/20{
  --tw-ring-color: rgb(70 72 212 / 0.2);
}
.ring-\\[\\#4648d4\\]\\/5{
  --tw-ring-color: rgb(70 72 212 / 0.05);
}
.ring-\\[\\#D9E7FF\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 231 255 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#ffffff\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-amber-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-amber-400\\/70{
  --tw-ring-color: rgb(251 191 36 / 0.7);
}
.ring-amber-500\\/80{
  --tw-ring-color: rgb(245 158 11 / 0.8);
}
.ring-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.ring-indigo-400\\/60{
  --tw-ring-color: rgb(129 140 248 / 0.6);
}
.ring-indigo-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500\\/30{
  --tw-ring-color: rgb(99 102 241 / 0.3);
}
.ring-sky-400\\/60{
  --tw-ring-color: rgb(56 189 248 / 0.6);
}
.ring-sky-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-200\\/80{
  --tw-ring-color: rgb(226 232 240 / 0.8);
}
.ring-slate-900\\/20{
  --tw-ring-color: rgb(15 23 42 / 0.2);
}
.ring-violet-500\\/30{
  --tw-ring-color: rgb(139 92 246 / 0.3);
}
.ring-violet-500\\/40{
  --tw-ring-color: rgb(139 92 246 / 0.4);
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/10{
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
.ring-white\\/15{
  --tw-ring-color: rgb(255 255 255 / 0.15);
}
.ring-white\\/70{
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
.ring-opacity-50{
  --tw-ring-opacity: 0.5;
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-\\[\\#07070a\\]{
  --tw-ring-offset-color: #07070a;
}
.ring-offset-white{
  --tw-ring-offset-color: #fff;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[0\\.5px\\]{
  --tw-blur: blur(0.5px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\]{
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[120px\\]{
  --tw-blur: blur(120px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[140px\\]{
  --tw-blur: blur(140px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[60px\\]{
  --tw-blur: blur(60px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[80px\\]{
  --tw-blur: blur(80px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[90px\\]{
  --tw-blur: blur(90px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-90{
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_2px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]{
  --tw-drop-shadow: drop-shadow(0 2px 4px rgba(0,0,0,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-3xl{
  --tw-backdrop-blur: blur(64px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[10px\\]{
  --tw-backdrop-blur: blur(10px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.duration-\\[150ms\\]{
  transition-duration: 150ms;
}
.duration-\\[400ms\\]{
  transition-duration: 400ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[opacity\\]{
  will-change: opacity;
}
@keyframes cover-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
.cover-fade-in {
    animation: cover-fade-in 0.5s ease-out forwards;
  }
@keyframes loader-shimmer {
    0% { background-position: -120% 0; }
    100% { background-position: 220% 0; }
  }
@keyframes loader-glow {
    0%, 100% { opacity: 0.6; filter: blur(12px); }
    50% { opacity: 1; filter: blur(16px); }
  }
.\\[animation-delay\\:150ms\\]{
  animation-delay: 150ms;
}
.\\[animation-delay\\:300ms\\]{
  animation-delay: 300ms;
}

body {
  font-style: normal;
  margin: 0;
  font-family: 'Outfit', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #ffffff;
  color: #0f172a;
  min-height: 100vh;
}

@media print {
  /* Allow background colors/images in print/PDF */
  * {
    print-color-adjust: exact !important;
  }
  .photobook-bg-wedding-cover,
  .photobook-bg-wedding,
  .photobook-bg-party {
    print-color-adjust: exact !important;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

/* Autofill: keep readable text on light and dark forms */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus,
select:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #0f172a !important;
  color: #0f172a !important;
  caret-color: #0f172a !important;
  background-color: #ffffff !important;
  background-image: none !important;
  -webkit-transition: background-color 99999s ease-in-out 0s;
  transition: background-color 99999s ease-in-out 0s;
}

html.dark input:-webkit-autofill,
html.dark input:-webkit-autofill:hover,
html.dark input:-webkit-autofill:focus,
html.dark input:-webkit-autofill:active,
html.dark textarea:-webkit-autofill,
html.dark textarea:-webkit-autofill:hover,
html.dark textarea:-webkit-autofill:focus,
html.dark textarea:-webkit-autofill:active,
html.dark select:-webkit-autofill,
html.dark select:-webkit-autofill:hover,
html.dark select:-webkit-autofill:focus,
html.dark select:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px #121214 inset !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  background-color: #121214 !important;
  background-image: none !important;
}

input:-internal-autofill-selected {
  appearance: menulist-button;
  background-image: none !important;
  background-color: #ffffff !important;
  color: #0f172a !important;
  -webkit-text-fill-color: #0f172a !important;
}

html.dark input:-internal-autofill-selected {
  background-color: #121214 !important;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

/* Icons next to autofilled fields */
input:-webkit-autofill ~ .text-icon,
input:-webkit-autofill:hover ~ .text-icon,
input:-webkit-autofill:focus ~ .text-icon,
input:-webkit-autofill:active ~ .text-icon,
input:-webkit-autofill + .text-icon,
input:-webkit-autofill:hover + .text-icon,
input:-webkit-autofill:focus + .text-icon,
input:-webkit-autofill:active + .text-icon {
  color: #64748b !important;
  opacity: 1 !important;
  filter: none !important;
}

html.dark input:-webkit-autofill ~ .text-icon,
html.dark input:-webkit-autofill:hover ~ .text-icon,
html.dark input:-webkit-autofill:focus ~ .text-icon,
html.dark input:-webkit-autofill:active ~ .text-icon,
html.dark input:-webkit-autofill + .text-icon,
html.dark input:-webkit-autofill:hover + .text-icon,
html.dark input:-webkit-autofill:focus + .text-icon,
html.dark input:-webkit-autofill:active + .text-icon {
  color: #94a3b8 !important;
}

/* Override autofill white text for light-background forms (invitations, etc.) */
.bg-white input:-webkit-autofill,
.bg-white input:-webkit-autofill:hover,
.bg-white input:-webkit-autofill:focus,
.bg-white input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #0f172a !important;
  color: #0f172a !important;
  background-color: #ffffff !important;
}
.to-purple-600,
.to-violet-600,
.to-indigo-600,
.to-blue-600,
.to-fuchsia-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position) !important;
}

.from-purple-600,
.from-violet-600,
.from-indigo-600,
.from-blue-600,
.from-fuchsia-600 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(20 18 16 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.marker\\:content-none *::marker{
  --tw-content: none;
  content: var(--tw-content);
}

.marker\\:content-none::marker{
  --tw-content: none;
  content: var(--tw-content);
}

.selection\\:bg-\\[\\#2563eb\\]\\/20 *::selection{
  background-color: rgb(37 99 235 / 0.2);
}

.selection\\:bg-violet-500\\/30 *::selection{
  background-color: rgb(139 92 246 / 0.3);
}

.selection\\:bg-\\[\\#2563eb\\]\\/20::selection{
  background-color: rgb(37 99 235 / 0.2);
}

.selection\\:bg-violet-500\\/30::selection{
  background-color: rgb(139 92 246 / 0.3);
}

.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}

.file\\:mr-4::file-selector-button{
  margin-right: 1rem;
}

.file\\:rounded-lg::file-selector-button{
  border-radius: 0.5rem;
}

.file\\:rounded-xl::file-selector-button{
  border-radius: 0.75rem;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-blue-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.file\\:bg-slate-900::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.file\\:px-4::file-selector-button{
  padding-left: 1rem;
  padding-right: 1rem;
}

.file\\:py-1\\.5::file-selector-button{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.file\\:text-\\[11px\\]::file-selector-button{
  font-size: 11px;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-semibold::file-selector-button{
  font-weight: 600;
}

.file\\:text-blue-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-\\[\\#94a3b8\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-\\[color\\:var\\(--ff-muted\\)\\]::placeholder{
  color: var(--ff-muted);
}

.placeholder\\:text-\\[color\\:var\\(--muted-foreground\\)\\]::placeholder{
  color: var(--muted-foreground);
}

.placeholder\\:text-gray-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-slate-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-white\\/40::placeholder{
  color: rgb(255 255 255 / 0.4);
}

.placeholder\\:text-white\\/45::placeholder{
  color: rgb(255 255 255 / 0.45);
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child{
  padding-bottom: 0px;
}

.open\\:bg-white[open]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-1:hover{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.03\\]:hover{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#004ac6\\]\\/50:hover{
  border-color: rgb(0 74 198 / 0.5);
}

.hover\\:border-\\[\\#2731db\\]\\/30:hover{
  border-color: rgb(39 49 219 / 0.3);
}

.hover\\:border-\\[\\#2731db\\]\\/40:hover{
  border-color: rgb(39 49 219 / 0.4);
}

.hover\\:border-\\[\\#4648d4\\]\\/30:hover{
  border-color: rgb(70 72 212 / 0.3);
}

.hover\\:border-\\[\\#4648d4\\]\\/40:hover{
  border-color: rgb(70 72 212 / 0.4);
}

.hover\\:border-\\[\\#8a5a2b\\]\\/20:hover{
  border-color: rgb(138 90 43 / 0.2);
}

.hover\\:border-\\[\\#c3c6d7\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(195 198 215 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[color\\:color-mix\\(in_oklab\\2c var\\(--primary\\)\\2c transparent_60\\%\\)\\]:hover{
  border-color: color-mix(in oklab,var(--primary),transparent 60%);
}

.hover\\:border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.1\\)\\]:hover{
  border-color: rgba(20,18,16,0.1);
}

.hover\\:border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.18\\)\\]:hover{
  border-color: rgba(20,18,16,0.18);
}

.hover\\:border-\\[rgba\\(20\\2c 18\\2c 16\\2c 0\\.22\\)\\]:hover{
  border-color: rgba(20,18,16,0.22);
}

.hover\\:border-blue-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-cyan-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300\\/60:hover{
  border-color: rgb(165 180 252 / 0.6);
}

.hover\\:border-indigo-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-rose-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-500\\/40:hover{
  border-color: rgb(139 92 246 / 0.4);
}

.hover\\:border-violet-500\\/50:hover{
  border-color: rgb(139 92 246 / 0.5);
}

.hover\\:border-white:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#1d4ed8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1f29c4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 196 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#2563eb\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#3a3cb8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(58 60 184 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#3d3fc0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(61 63 192 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#4648d4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(70 72 212 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#4648d4\\]\\/5:hover{
  background-color: rgb(70 72 212 / 0.05);
}

.hover\\:bg-\\[\\#8a5a2b\\]\\/10:hover{
  background-color: rgb(138 90 43 / 0.1);
}

.hover\\:bg-\\[\\#d0e1fb\\]\\/20:hover{
  background-color: rgb(208 225 251 / 0.2);
}

.hover\\:bg-\\[\\#eff6ff\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f1f5f9\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f3f3fe\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[color\\:var\\(--ff-primary-soft\\)\\]:hover{
  background-color: var(--ff-primary-soft);
}

.hover\\:bg-\\[var\\(--muted\\)\\]:hover{
  background-color: var(--muted);
}

.hover\\:bg-amber-200\\/60:hover{
  background-color: rgb(253 230 138 / 0.6);
}

.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black\\/50:hover{
  background-color: rgb(0 0 0 / 0.5);
}

.hover\\:bg-black\\/60:hover{
  background-color: rgb(0 0 0 / 0.6);
}

.hover\\:bg-black\\/70:hover{
  background-color: rgb(0 0 0 / 0.7);
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/60:hover{
  background-color: rgb(239 246 255 / 0.6);
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-50\\/90:hover{
  background-color: rgb(236 254 255 / 0.9);
}

.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50\\/80:hover{
  background-color: rgb(238 242 255 / 0.8);
}

.hover\\:bg-indigo-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50\\/90:hover{
  background-color: rgb(255 241 242 / 0.9);
}

.hover\\:bg-rose-500\\/30:hover{
  background-color: rgb(244 63 94 / 0.3);
}

.hover\\:bg-sky-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50\\/60:hover{
  background-color: rgb(248 250 252 / 0.6);
}

.hover\\:bg-slate-50\\/80:hover{
  background-color: rgb(248 250 252 / 0.8);
}

.hover\\:bg-slate-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-50\\/40:hover{
  background-color: rgb(245 243 255 / 0.4);
}

.hover\\:bg-violet-50\\/50:hover{
  background-color: rgb(245 243 255 / 0.5);
}

.hover\\:bg-violet-600\\/30:hover{
  background-color: rgb(124 58 237 / 0.3);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}

.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}

.hover\\:bg-white\\/40:hover{
  background-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-white\\/50:hover{
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-white\\/70:hover{
  background-color: rgb(255 255 255 / 0.7);
}

.hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}

.hover\\:bg-white\\/\\[0\\.06\\]:hover{
  background-color: rgb(255 255 255 / 0.06);
}

.hover\\:bg-white\\/\\[0\\.12\\]:hover{
  background-color: rgb(255 255 255 / 0.12);
}

.hover\\:bg-white\\/\\[0\\.1\\]:hover{
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-opacity-20:hover{
  --tw-bg-opacity: 0.2;
}

.hover\\:bg-opacity-30:hover{
  --tw-bg-opacity: 0.3;
}

.hover\\:bg-gradient-to-br:hover{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.hover\\:from-blue-200:hover{
  --tw-gradient-from: #bfdbfe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(191 219 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-700:hover{
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-cyan-100:hover{
  --tw-gradient-from: #cffafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(207 250 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-gray-200:hover{
  --tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 231 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-gray-700:hover{
  --tw-gradient-from: #374151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-600:hover{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-700:hover{
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-200:hover{
  --tw-gradient-from: #c7d2fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(199 210 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-700:hover{
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-200:hover{
  --tw-gradient-from: #fecaca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 202 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-600:hover{
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-700:hover{
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-violet-500:hover{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-yellow-600:hover{
  --tw-gradient-from: #ca8a04 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(202 138 4 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-blue-700:hover{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-700:hover{
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}

.hover\\:to-fuchsia-500:hover{
  --tw-gradient-to: #d946ef var(--tw-gradient-to-position);
}

.hover\\:to-gray-300:hover{
  --tw-gradient-to: #d1d5db var(--tw-gradient-to-position);
}

.hover\\:to-gray-800:hover{
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}

.hover\\:to-indigo-100:hover{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}

.hover\\:to-indigo-200:hover{
  --tw-gradient-to: #c7d2fe var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.hover\\:to-orange-700:hover{
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}

.hover\\:to-pink-200:hover{
  --tw-gradient-to: #fbcfe8 var(--tw-gradient-to-position);
}

.hover\\:to-pink-700:hover{
  --tw-gradient-to: #be185d var(--tw-gradient-to-position);
}

.hover\\:to-purple-200:hover{
  --tw-gradient-to: #e9d5ff var(--tw-gradient-to-position);
}

.hover\\:to-purple-700:hover{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:to-violet-700:hover{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}

.hover\\:text-\\[\\#004ac6\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(0 74 198 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#0f172a\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#191b23\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(25 27 35 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#4648d4\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(70 72 212 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#ba1a1a\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(186 26 26 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-700:hover{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-300:hover{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-900:hover{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-700:hover{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-200:hover{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-300:hover{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-900:hover{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-500:hover{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-300:hover{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-500:hover{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-700:hover{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-900:hover{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-200:hover{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-300:hover{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-600:hover{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-700:hover{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-white\\/70:hover{
  color: rgb(255 255 255 / 0.7);
}

.hover\\:text-yellow-800:hover{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-900:hover{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:no-underline:hover{
  text-decoration-line: none;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:opacity-95:hover{
  opacity: 0.95;
}

.hover\\:shadow-2xl:hover{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_10px_20px_-8px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.7\\)\\]:hover{
  --tw-shadow: 0 10px 20px -8px rgba(37,99,235,0.7);
  --tw-shadow-colored: 0 10px 20px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_10px_24px_rgba\\(39\\2c 49\\2c 219\\2c 0\\.36\\)\\]:hover{
  --tw-shadow: 0 10px 24px rgba(39,49,219,0.36);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_15px_25px_-5px_rgba\\(70\\2c 72\\2c 212\\2c 0\\.5\\)\\]:hover{
  --tw-shadow: 0 15px 25px -5px rgba(70,72,212,0.5);
  --tw-shadow-colored: 0 15px 25px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_16px_48px_-8px_rgba\\(217\\2c 70\\2c 239\\2c 0\\.45\\)\\]:hover{
  --tw-shadow: 0 16px 48px -8px rgba(217,70,239,0.45);
  --tw-shadow-colored: 0 16px 48px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_24px_50px_-20px_rgba\\(79\\2c 70\\2c 229\\2c 0\\.35\\)\\]:hover{
  --tw-shadow: 0 24px 50px -20px rgba(79,70,229,0.35);
  --tw-shadow-colored: 0 24px 50px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_8px_18px_-4px_rgba\\(79\\2c 70\\2c 229\\2c 0\\.7\\)\\]:hover{
  --tw-shadow: 0 8px 18px -4px rgba(79,70,229,0.7);
  --tw-shadow-colored: 0 8px 18px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[\\#4648d4\\]\\/30:hover{
  --tw-shadow-color: rgb(70 72 212 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:ring-2:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-indigo-300:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-violet-400\\/45:hover{
  --tw-ring-color: rgb(167 139 250 / 0.45);
}

.hover\\:brightness-105:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:brightness-\\[1\\.03\\]:hover{
  --tw-brightness: brightness(1.03);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:file\\:bg-blue-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:file\\:bg-slate-800::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.focus\\:border-\\[\\#004ac6\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 74 198 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#2563eb\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#2731db\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(39 49 219 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#4648d4\\]\\/50:focus{
  border-color: rgb(70 72 212 / 0.5);
}

.focus\\:border-\\[color\\:var\\(--ff-primary\\)\\]:focus{
  border-color: var(--ff-primary);
}

.focus\\:border-\\[color\\:var\\(--primary\\)\\]:focus{
  border-color: var(--primary);
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.focus\\:border-cyan-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}

.focus\\:border-green-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-slate-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:border-violet-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}

.focus\\:border-violet-500\\/40:focus{
  border-color: rgb(139 92 246 / 0.4);
}

.focus\\:border-white\\/60:focus{
  border-color: rgb(255 255 255 / 0.6);
}

.focus\\:border-yellow-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#004ac6\\]\\/20:focus{
  --tw-ring-color: rgb(0 74 198 / 0.2);
}

.focus\\:ring-\\[\\#004ac6\\]\\/30:focus{
  --tw-ring-color: rgb(0 74 198 / 0.3);
}

.focus\\:ring-\\[\\#2563eb\\]\\/30:focus{
  --tw-ring-color: rgb(37 99 235 / 0.3);
}

.focus\\:ring-\\[\\#2563eb\\]\\/40:focus{
  --tw-ring-color: rgb(37 99 235 / 0.4);
}

.focus\\:ring-\\[\\#2731db\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(39 49 219 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[\\#2731db\\]\\/20:focus{
  --tw-ring-color: rgb(39 49 219 / 0.2);
}

.focus\\:ring-\\[\\#4648d4\\]\\/30:focus{
  --tw-ring-color: rgb(70 72 212 / 0.3);
}

.focus\\:ring-\\[\\#4648d4\\]\\/40:focus{
  --tw-ring-color: rgb(70 72 212 / 0.4);
}

.focus\\:ring-\\[\\#513cd2\\]\\/40:focus{
  --tw-ring-color: rgb(81 60 210 / 0.4);
}

.focus\\:ring-\\[\\#630ed4\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 14 212 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[color\\:var\\(--ff-ring\\)\\]:focus{
  --tw-ring-color: var(--ff-ring);
}

.focus\\:ring-\\[color\\:var\\(--ring\\)\\]:focus{
  --tw-ring-color: var(--ring);
}

.focus\\:ring-\\[rgba\\(31\\2c 58\\2c 52\\2c 0\\.12\\)\\]:focus{
  --tw-ring-color: rgba(31,58,52,0.12);
}

.focus\\:ring-\\[rgba\\(31\\2c 58\\2c 52\\2c 0\\.18\\)\\]:focus{
  --tw-ring-color: rgba(31,58,52,0.18);
}

.focus\\:ring-\\[rgba\\(31\\2c 58\\2c 52\\2c 0\\.22\\)\\]:focus{
  --tw-ring-color: rgba(31,58,52,0.22);
}

.focus\\:ring-amber-500\\/20:focus{
  --tw-ring-color: rgb(245 158 11 / 0.2);
}

.focus\\:ring-blue-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-400\\/40:focus{
  --tw-ring-color: rgb(34 211 238 / 0.4);
}

.focus\\:ring-cyan-500\\/20:focus{
  --tw-ring-color: rgb(6 182 212 / 0.2);
}

.focus\\:ring-cyan-500\\/30:focus{
  --tw-ring-color: rgb(6 182 212 / 0.3);
}

.focus\\:ring-emerald-500\\/30:focus{
  --tw-ring-color: rgb(16 185 129 / 0.3);
}

.focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400\\/20:focus{
  --tw-ring-color: rgb(129 140 248 / 0.2);
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}

.focus\\:ring-indigo-500\\/25:focus{
  --tw-ring-color: rgb(99 102 241 / 0.25);
}

.focus\\:ring-indigo-500\\/30:focus{
  --tw-ring-color: rgb(99 102 241 / 0.3);
}

.focus\\:ring-primary-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-rose-400\\/40:focus{
  --tw-ring-color: rgb(251 113 133 / 0.4);
}

.focus\\:ring-violet-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-violet-500\\/25:focus{
  --tw-ring-color: rgb(139 92 246 / 0.25);
}

.focus\\:ring-violet-500\\/30:focus{
  --tw-ring-color: rgb(139 92 246 / 0.3);
}

.focus\\:ring-violet-500\\/40:focus{
  --tw-ring-color: rgb(139 92 246 / 0.4);
}

.focus\\:ring-violet-500\\/50:focus{
  --tw-ring-color: rgb(139 92 246 / 0.5);
}

.focus\\:ring-white\\/40:focus{
  --tw-ring-color: rgb(255 255 255 / 0.4);
}

.focus\\:ring-white\\/50:focus{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-yellow-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(234 179 8 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus\\:ring-offset-\\[\\#07070a\\]:focus{
  --tw-ring-offset-color: #07070a;
}

.focus\\:ring-offset-\\[\\#0a0a0c\\]:focus{
  --tw-ring-offset-color: #0a0a0c;
}

.focus\\:ring-offset-\\[\\#ffffff\\]:focus{
  --tw-ring-offset-color: #ffffff;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-\\[\\#2731db\\]:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(39 49 219 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-indigo-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-violet-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.active\\:translate-y-0:active{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.active\\:bg-gray-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:transform-none:disabled{
  transform: none;
}

.disabled\\:cursor-default:disabled{
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-gray-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-0:disabled{
  opacity: 0;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group:focus-within .group-focus-within\\:text-\\[\\#2563eb\\]{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.group:focus-within .group-focus-within\\:text-\\[\\#2731db\\]{
  --tw-text-opacity: 1;
  color: rgb(39 49 219 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:pointer-events-auto{
  pointer-events: auto;
}

.group:hover .group-hover\\:flex{
  display: flex;
}

.group:hover .group-hover\\:-translate-x-0\\.5{
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/drop:hover .group-hover\\/drop\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.03\\]{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse{
  50%{
    opacity: .5;
  }
}

.group:hover .group-hover\\:animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.group\\/slot:hover .group-hover\\/slot\\:bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}

.group:hover .group-hover\\:bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}

.group:hover .group-hover\\:bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}

.group:hover .group-hover\\:bg-black\\/25{
  background-color: rgb(0 0 0 / 0.25);
}

.group:hover .group-hover\\:bg-black\\/5{
  background-color: rgb(0 0 0 / 0.05);
}

.group:hover .group-hover\\:bg-opacity-10{
  --tw-bg-opacity: 0.1;
}

.group:hover .group-hover\\:text-\\[\\#64748b\\]{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-\\[color\\:var\\(--primary\\)\\]{
  color: var(--primary);
}

.group:hover .group-hover\\:text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.group\\/crop:hover .group-hover\\/crop\\:opacity-100{
  opacity: 1;
}

.group\\/slot:hover .group-hover\\/slot\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:active .group-active\\:scale-\\[0\\.98\\]{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.peer:focus ~ .peer-focus\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.has-\\[\\:checked\\]\\:border-\\[\\#513cd2\\]:has(:checked){
  --tw-border-opacity: 1;
  border-color: rgb(81 60 210 / var(--tw-border-opacity, 1));
}

.has-\\[\\:checked\\]\\:text-\\[\\#513cd2\\]:has(:checked){
  --tw-text-opacity: 1;
  color: rgb(81 60 210 / var(--tw-text-opacity, 1));
}

.has-\\[\\:checked\\]\\:ring-1:has(:checked){
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.has-\\[\\:checked\\]\\:ring-\\[\\#513cd2\\]\\/30:has(:checked){
  --tw-ring-color: rgb(81 60 210 / 0.3);
}

@supports (backdrop-filter: var(--tw)){
  .supports-\\[backdrop-filter\\]\\:bg-black\\/25{
    background-color: rgb(0 0 0 / 0.25);
  }
  .supports-\\[backdrop-filter\\]\\:bg-black\\/35{
    background-color: rgb(0 0 0 / 0.35);
  }
}

.dark\\:border-\\[\\#151412\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(21 20 18 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#1c1a18\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(28 26 24 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-900\\/50:is(.dark *){
  border-color: rgb(120 53 15 / 0.5);
}

.dark\\:border-blue-500\\/30:is(.dark *){
  border-color: rgb(59 130 246 / 0.3);
}

.dark\\:border-blue-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-900\\/50:is(.dark *){
  border-color: rgb(30 58 138 / 0.5);
}

.dark\\:border-emerald-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}

.dark\\:border-emerald-900\\/50:is(.dark *){
  border-color: rgb(6 78 59 / 0.5);
}

.dark\\:border-indigo-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-900\\/50:is(.dark *){
  border-color: rgb(49 46 129 / 0.5);
}

.dark\\:border-red-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-900\\/50:is(.dark *){
  border-color: rgb(136 19 55 / 0.5);
}

.dark\\:border-slate-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700\\/60:is(.dark *){
  border-color: rgb(51 65 85 / 0.6);
}

.dark\\:border-slate-700\\/80:is(.dark *){
  border-color: rgb(51 65 85 / 0.8);
}

.dark\\:border-slate-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}

.dark\\:border-violet-800\\/60:is(.dark *){
  border-color: rgb(91 33 182 / 0.6);
}

.dark\\:border-violet-900\\/50:is(.dark *){
  border-color: rgb(76 29 149 / 0.5);
}

.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border-white\\/15:is(.dark *){
  border-color: rgb(255 255 255 / 0.15);
}

.dark\\:border-white\\/20:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:bg-\\[\\#0a0a0c\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 12 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#0f172a\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#121214\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 20 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#151412\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(21 20 18 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#1c1a18\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(28 26 24 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#1c1a18\\]\\/90:is(.dark *){
  background-color: rgb(28 26 24 / 0.9);
}

.dark\\:bg-\\[\\#1c1a18\\]\\/95:is(.dark *){
  background-color: rgb(28 26 24 / 0.95);
}

.dark\\:bg-\\[\\#1e293b\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#1e293b\\]\\/90:is(.dark *){
  background-color: rgb(30 41 59 / 0.9);
}

.dark\\:bg-\\[\\#64748b\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#ffffff\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[rgba\\(21\\2c 20\\2c 18\\2c 0\\.9\\)\\]:is(.dark *){
  background-color: rgba(21,20,18,0.9);
}

.dark\\:bg-amber-950\\/40:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:bg-amber-950\\/60:is(.dark *){
  background-color: rgb(69 26 3 / 0.6);
}

.dark\\:bg-black\\/60:is(.dark *){
  background-color: rgb(0 0 0 / 0.6);
}

.dark\\:bg-black\\/70:is(.dark *){
  background-color: rgb(0 0 0 / 0.7);
}

.dark\\:bg-blue-950\\/30:is(.dark *){
  background-color: rgb(23 37 84 / 0.3);
}

.dark\\:bg-blue-950\\/40:is(.dark *){
  background-color: rgb(23 37 84 / 0.4);
}

.dark\\:bg-blue-950\\/50:is(.dark *){
  background-color: rgb(23 37 84 / 0.5);
}

.dark\\:bg-blue-950\\/60:is(.dark *){
  background-color: rgb(23 37 84 / 0.6);
}

.dark\\:bg-emerald-950\\/40:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:bg-emerald-950\\/60:is(.dark *){
  background-color: rgb(2 44 34 / 0.6);
}

.dark\\:bg-fuchsia-500\\/\\[0\\.06\\]:is(.dark *){
  background-color: rgb(217 70 239 / 0.06);
}

.dark\\:bg-indigo-400\\/\\[0\\.04\\]:is(.dark *){
  background-color: rgb(129 140 248 / 0.04);
}

.dark\\:bg-indigo-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-950\\/40:is(.dark *){
  background-color: rgb(30 27 75 / 0.4);
}

.dark\\:bg-indigo-950\\/60:is(.dark *){
  background-color: rgb(30 27 75 / 0.6);
}

.dark\\:bg-red-950\\/40:is(.dark *){
  background-color: rgb(69 10 10 / 0.4);
}

.dark\\:bg-rose-950\\/40:is(.dark *){
  background-color: rgb(76 5 25 / 0.4);
}

.dark\\:bg-rose-950\\/60:is(.dark *){
  background-color: rgb(76 5 25 / 0.6);
}

.dark\\:bg-slate-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800\\/30:is(.dark *){
  background-color: rgb(30 41 59 / 0.3);
}

.dark\\:bg-slate-800\\/40:is(.dark *){
  background-color: rgb(30 41 59 / 0.4);
}

.dark\\:bg-slate-800\\/50:is(.dark *){
  background-color: rgb(30 41 59 / 0.5);
}

.dark\\:bg-slate-800\\/60:is(.dark *){
  background-color: rgb(30 41 59 / 0.6);
}

.dark\\:bg-slate-800\\/70:is(.dark *){
  background-color: rgb(30 41 59 / 0.7);
}

.dark\\:bg-slate-800\\/80:is(.dark *){
  background-color: rgb(30 41 59 / 0.8);
}

.dark\\:bg-slate-800\\/90:is(.dark *){
  background-color: rgb(30 41 59 / 0.9);
}

.dark\\:bg-slate-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-900\\/70:is(.dark *){
  background-color: rgb(15 23 42 / 0.7);
}

.dark\\:bg-slate-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-violet-500\\/\\[0\\.08\\]:is(.dark *){
  background-color: rgb(139 92 246 / 0.08);
}

.dark\\:bg-violet-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-violet-950\\/40:is(.dark *){
  background-color: rgb(46 16 101 / 0.4);
}

.dark\\:bg-violet-950\\/60:is(.dark *){
  background-color: rgb(46 16 101 / 0.6);
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-white\\/\\[0\\.03\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:bg-white\\/\\[0\\.04\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.04);
}

.dark\\:from-slate-900:is(.dark *){
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-slate-950:is(.dark *){
  --tw-gradient-from: #020617 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-slate-600:is(.dark *){
  --tw-gradient-to: rgb(71 85 105 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #475569 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-slate-900:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0f172a var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-slate-900\\/80:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-slate-800:is(.dark *){
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}

.dark\\:to-slate-900:is(.dark *){
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}

.dark\\:to-slate-950:is(.dark *){
  --tw-gradient-to: #020617 var(--tw-gradient-to-position);
}

.dark\\:text-\\[\\#0f172a\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#0f172a\\]\\/70:is(.dark *){
  color: rgb(15 23 42 / 0.7);
}

.dark\\:text-\\[\\#64748b\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#78746c\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(120 116 108 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#94a3b8\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#a8a399\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(168 163 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#c5a07a\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(197 160 122 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#e2e8f0\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#ffffff\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-fuchsia-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-50:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:shadow-\\[0_16px_48px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:is(.dark *){
  --tw-shadow: 0 16px 48px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_18px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]:is(.dark *){
  --tw-shadow: 0 18px 60px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 18px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_20px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]:is(.dark *){
  --tw-shadow: 0 20px 70px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 20px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_24px_60px_-40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]:is(.dark *){
  --tw-shadow: 0 24px 60px -40px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 24px 60px -40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_24px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]:is(.dark *){
  --tw-shadow: 0 24px 80px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_8px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]:is(.dark *){
  --tw-shadow: 0 8px 32px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-violet-900\\/30:is(.dark *){
  --tw-shadow-color: rgb(76 29 149 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:ring-\\[\\#1c1a18\\]:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 26 24 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-slate-700:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 65 85 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-slate-900:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}

.dark\\:selection\\:bg-\\[\\#2563eb\\]\\/40 *:is(.dark *)::selection{
  background-color: rgb(37 99 235 / 0.4);
}

.dark\\:selection\\:bg-violet-500\\/40 *:is(.dark *)::selection{
  background-color: rgb(139 92 246 / 0.4);
}

.dark\\:selection\\:bg-\\[\\#2563eb\\]\\/40:is(.dark *)::selection{
  background-color: rgb(37 99 235 / 0.4);
}

.dark\\:selection\\:bg-violet-500\\/40:is(.dark *)::selection{
  background-color: rgb(139 92 246 / 0.4);
}

.dark\\:placeholder\\:text-\\[\\#78746c\\]:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(120 116 108 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder\\:text-slate-500:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.dark\\:open\\:bg-slate-900[open]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:border-blue-500:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-500\\/50:hover:is(.dark *){
  border-color: rgb(99 102 241 / 0.5);
}

.dark\\:hover\\:border-indigo-700:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-slate-500:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-slate-600:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-violet-700:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-white\\/20:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:bg-blue-950\\/40:hover:is(.dark *){
  background-color: rgb(23 37 84 / 0.4);
}

.dark\\:hover\\:bg-indigo-400:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-indigo-950\\/40:hover:is(.dark *){
  background-color: rgb(30 27 75 / 0.4);
}

.dark\\:hover\\:bg-rose-900\\/50:hover:is(.dark *){
  background-color: rgb(136 19 55 / 0.5);
}

.dark\\:hover\\:bg-slate-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-800\\/60:hover:is(.dark *){
  background-color: rgb(30 41 59 / 0.6);
}

.dark\\:hover\\:bg-violet-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-white:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/20:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:hover\\:bg-white\\/\\[0\\.07\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.07);
}

.dark\\:hover\\:text-\\[\\#ffffff\\]:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-amber-100:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-blue-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-\\[\\#a8a399\\]:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(168 163 153 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-\\[\\#e2e8f0\\]:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-indigo-400:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:ring-indigo-400\\/25:focus:is(.dark *){
  --tw-ring-color: rgb(129 140 248 / 0.25);
}

.dark\\:focus\\:ring-white\\/10:focus:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.1);
}

.dark\\:focus\\:ring-white\\/15:focus:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.15);
}

.dark\\:focus\\:ring-offset-\\[\\#151412\\]:focus:is(.dark *){
  --tw-ring-offset-color: #151412;
}

.group:focus-within .dark\\:group-focus-within\\:text-\\[\\#2563eb\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px){
  .sm\\:inset-x-3{
    left: 0.75rem;
    right: 0.75rem;
  }
  .sm\\:inset-x-4{
    left: 1rem;
    right: 1rem;
  }
  .sm\\:bottom-3{
    bottom: 0.75rem;
  }
  .sm\\:bottom-4{
    bottom: 1rem;
  }
  .sm\\:left-\\[308px\\]{
    left: 308px;
  }
  .sm\\:left-auto{
    left: auto;
  }
  .sm\\:right-4{
    right: 1rem;
  }
  .sm\\:top-3{
    top: 0.75rem;
  }
  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .sm\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .sm\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .sm\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .sm\\:-mt-8{
    margin-top: -2rem;
  }
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:mb-8{
    margin-bottom: 2rem;
  }
  .sm\\:ml-4{
    margin-left: 1rem;
  }
  .sm\\:ml-6{
    margin-left: 1.5rem;
  }
  .sm\\:ml-auto{
    margin-left: auto;
  }
  .sm\\:mr-2{
    margin-right: 0.5rem;
  }
  .sm\\:mt-2{
    margin-top: 0.5rem;
  }
  .sm\\:mt-3{
    margin-top: 0.75rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:inline-flex{
    display: inline-flex;
  }
  .sm\\:grid{
    display: grid;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:aspect-square{
    aspect-ratio: 1 / 1;
  }
  .sm\\:h-16{
    height: 4rem;
  }
  .sm\\:h-4{
    height: 1rem;
  }
  .sm\\:h-44{
    height: 11rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-8{
    height: 2rem;
  }
  .sm\\:max-h-24{
    max-height: 6rem;
  }
  .sm\\:max-h-\\[340px\\]{
    max-height: 340px;
  }
  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }
  .sm\\:min-h-0{
    min-height: 0px;
  }
  .sm\\:min-h-\\[46vh\\]{
    min-height: 46vh;
  }
  .sm\\:w-16{
    width: 4rem;
  }
  .sm\\:w-24{
    width: 6rem;
  }
  .sm\\:w-4{
    width: 1rem;
  }
  .sm\\:w-6{
    width: 1.5rem;
  }
  .sm\\:w-8{
    width: 2rem;
  }
  .sm\\:w-80{
    width: 20rem;
  }
  .sm\\:w-\\[240px\\]{
    width: 240px;
  }
  .sm\\:w-\\[320px\\]{
    width: 320px;
  }
  .sm\\:w-\\[340px\\]{
    width: 340px;
  }
  .sm\\:w-\\[380px\\]{
    width: 380px;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:min-w-0{
    min-width: 0px;
  }
  .sm\\:min-w-\\[11rem\\]{
    min-width: 11rem;
  }
  .sm\\:max-w-\\[200px\\]{
    max-width: 200px;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:max-w-none{
    max-width: none;
  }
  .sm\\:max-w-xl{
    max-width: 36rem;
  }
  .sm\\:flex-1{
    flex: 1 1;
  }
  .sm\\:flex-none{
    flex: none;
  }
  .sm\\:basis-\\[200px\\]{
    flex-basis: 200px;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sm\\:grid-cols-\\[96px_1fr\\]{
    grid-template-columns: 96px 1fr;
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-1\\.5{
    gap: 0.375rem;
  }
  .sm\\:gap-10{
    gap: 2.5rem;
  }
  .sm\\:gap-2{
    gap: 0.5rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-6{
    gap: 1.5rem;
  }
  .sm\\:gap-8{
    gap: 2rem;
  }
  .sm\\:gap-x-4{
    column-gap: 1rem;
  }
  .sm\\:gap-y-1\\.5{
    row-gap: 0.375rem;
  }
  .sm\\:space-x-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }
  .sm\\:self-auto{
    align-self: auto;
  }
  .sm\\:overflow-visible{
    overflow: visible;
  }
  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }
  .sm\\:rounded-\\[2\\.5rem\\]{
    border-radius: 2.5rem;
  }
  .sm\\:p-10{
    padding: 2.5rem;
  }
  .sm\\:p-2{
    padding: 0.5rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:p-7{
    padding: 1.75rem;
  }
  .sm\\:p-8{
    padding: 2rem;
  }
  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-3\\.5{
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .sm\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:pb-20{
    padding-bottom: 5rem;
  }
  .sm\\:pt-0{
    padding-top: 0px;
  }
  .sm\\:pt-14{
    padding-top: 3.5rem;
  }
  .sm\\:pt-24{
    padding-top: 6rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-right{
    text-align: right;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-\\[0\\.95rem\\]{
    font-size: 0.95rem;
  }
  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }
  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .sm\\:leading-\\[1\\.05\\]{
    line-height: 1.05;
  }
  .sm\\:hover\\:-translate-y-0\\.5:hover{
    --tw-translate-y: -0.125rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:hover\\:-translate-y-1:hover{
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 768px){
  .md\\:left-6{
    left: 1.5rem;
  }
  .md\\:right-6{
    right: 1.5rem;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }
  .md\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .md\\:mb-8{
    margin-bottom: 2rem;
  }
  .md\\:block{
    display: block;
  }
  .md\\:inline{
    display: inline;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:h-\\[90px\\]{
    height: 90px;
  }
  .md\\:h-auto{
    height: auto;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-\\[120px\\]{
    width: 120px;
  }
  .md\\:flex-shrink-0{
    flex-shrink: 0;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-end{
    align-items: flex-end;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:gap-6{
    gap: 1.5rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .md\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .md\\:pr-3{
    padding-right: 0.75rem;
  }
  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px){
  .lg\\:fixed{
    position: fixed;
  }
  .lg\\:sticky{
    position: sticky;
  }
  .lg\\:inset-y-0{
    top: 0px;
    bottom: 0px;
  }
  .lg\\:left-64{
    left: 16rem;
  }
  .lg\\:left-\\[240px\\]{
    left: 240px;
  }
  .lg\\:top-16{
    top: 4rem;
  }
  .lg\\:z-50{
    z-index: 50;
  }
  .lg\\:order-none{
    order: 0;
  }
  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-12{
    grid-column: span 12 / span 12;
  }
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }
  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }
  .lg\\:-m-3{
    margin: -0.75rem;
  }
  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .lg\\:ml-\\[240px\\]{
    margin-left: 240px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:inline{
    display: inline;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:max-h-\\[calc\\(100dvh-9rem\\)\\]{
    max-height: calc(100dvh - 9rem);
  }
  .lg\\:max-h-none{
    max-height: none;
  }
  .lg\\:w-72{
    width: 18rem;
  }
  .lg\\:w-80{
    width: 20rem;
  }
  .lg\\:w-\\[380px\\]{
    width: 380px;
  }
  .lg\\:max-w-none{
    max-width: none;
  }
  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[1\\.05fr_min\\(26\\.5rem\\2c 100\\%\\)\\]{
    grid-template-columns: 1.05fr min(26.5rem, 100%);
  }
  .lg\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }
  .lg\\:grid-cols-\\[1fr_min\\(28rem\\2c 100\\%\\)\\]{
    grid-template-columns: 1fr min(28rem, 100%);
  }
  .lg\\:grid-cols-\\[1fr_min\\(32rem\\2c 100\\%\\)\\]{
    grid-template-columns: 1fr min(32rem, 100%);
  }
  .lg\\:grid-cols-\\[220px_1fr\\]{
    grid-template-columns: 220px 1fr;
  }
  .lg\\:grid-cols-\\[260px_1fr_300px\\]{
    grid-template-columns: 260px 1fr 300px;
  }
  .lg\\:grid-cols-\\[300px_1fr\\]{
    grid-template-columns: 300px 1fr;
  }
  .lg\\:grid-cols-\\[340px_1fr_340px\\]{
    grid-template-columns: 340px 1fr 340px;
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-col{
    flex-direction: column;
  }
  .lg\\:items-start{
    align-items: flex-start;
  }
  .lg\\:items-end{
    align-items: flex-end;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-end{
    justify-content: flex-end;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:gap-16{
    gap: 4rem;
  }
  .lg\\:self-start{
    align-self: flex-start;
  }
  .lg\\:border-l{
    border-left-width: 1px;
  }
  .lg\\:border-t-0{
    border-top-width: 0px;
  }
  .lg\\:p-10{
    padding: 2.5rem;
  }
  .lg\\:p-3{
    padding: 0.75rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:pb-24{
    padding-bottom: 6rem;
  }
  .lg\\:pl-80{
    padding-left: 20rem;
  }
  .lg\\:pr-80{
    padding-right: 20rem;
  }
  .lg\\:text-\\[2\\.75rem\\]{
    font-size: 2.75rem;
  }
  .lg\\:text-\\[26px\\]{
    font-size: 26px;
  }
  .lg\\:text-\\[3rem\\]{
    font-size: 3rem;
  }
}

@media (min-width: 1280px){
  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .xl\\:flex{
    display: flex;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:max-h-none{
    max-height: none;
  }
  .xl\\:w-\\[420px\\]{
    width: 420px;
  }
  .xl\\:max-w-xl{
    max-width: 36rem;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .xl\\:flex-row{
    flex-direction: row;
  }
  .xl\\:border-l{
    border-left-width: 1px;
  }
  .xl\\:border-t-0{
    border-top-width: 0px;
  }
  .xl\\:pb-20{
    padding-bottom: 5rem;
  }
  .xl\\:text-\\[1\\.05rem\\]{
    font-size: 1.05rem;
  }
  .xl\\:text-\\[2\\.75rem\\]{
    font-size: 2.75rem;
  }
  .xl\\:text-\\[3\\.1rem\\]{
    font-size: 3.1rem;
  }
  .xl\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .xl\\:leading-\\[1\\.1\\]{
    line-height: 1.1;
  }
}

@media print{
  .print\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

.\\[\\&_\\.swiper-button-next\\]\\:text-white .swiper-button-next{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.\\[\\&_\\.swiper-button-next\\]\\:drop-shadow .swiper-button-next{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.\\[\\&_\\.swiper-button-prev\\]\\:text-white .swiper-button-prev{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.\\[\\&_\\.swiper-button-prev\\]\\:drop-shadow .swiper-button-prev{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;IAAA,sCAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;;IAAd,mBAAc;IAAd,qBAAc;IAAd,iBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,oBAAc;;IAAd,kBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,4BAAc;IAAd,iDAAc;IAAd,qDAAc;IAAd,yDAAc;EAAA;AAAd;IAAA,4BAAc;IAAd,mDAAc;IAAd,oDAAc;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AA0EhB;EAAA,qBAA4H;EAA5H,kBAA4H;EAA5H,0DAA4H;EAA5H,oBAA4H;EAA5H,qBAA4H;EAA5H,oBAA4H;EAA5H,uBAA4H;EAA5H,gBAA4H;EAA5H,oBAA4H;EAA5H,mDAA4H;EAA5H,0CAA4H;EAA5H,uDAA4H;EAA5H,uGAA4H;EAA5H,wBAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H;AAA4H;AAI5H;EAAA,qBAAgI;EAAhI,kBAAgI;EAAhI,4DAAgI;EAAhI,oBAAgI;EAAhI,qBAAgI;EAAhI,oBAAgI;EAAhI,uBAAgI;EAAhI,gBAAgI;EAAhI,oBAAgI;EAAhI,gDAAgI;EAAhI,0CAAgI;EAAhI,uDAAgI;EAAhI,uGAAgI;EAAhI,wBAAgI;EAAhI,wDAAgI;EAAhI;AAAgI;AAAhI;EAAA,kBAAgI;EAAhI;AAAgI;AAQhI;EAAA,WAAwT;EAAxT,sBAAwT;EAAxT,iBAAwT;EAAxT,sBAAwT;EAAxT,4DAAwT;EAAxT,wCAAwT;EAAxT,kBAAwT;EAAxT,mBAAwT;EAAxT,oBAAwT;EAAxT,uBAAwT;EAAxT,oBAAwT;EAAxT,gDAAwT;EAAxT,6BAAwT;EAAxT,uQAAwT;EAAxT,wBAAwT;EAAxT,wDAAwT;EAAxT;AAAwT;AAAxT;EAAA,oBAAwT;EAAxT;AAAwT;AAAxT;EAAA,yBAAwT;EAAxT,2GAAwT;EAAxT,yGAAwT;EAAxT,4FAAwT;EAAxT,oBAAwT;EAAxT;AAAwT;AAAxT;EAAA,sBAAwT;EAAxT,0DAAwT;EAAxT,qCAAwT;EAAxT,oBAAwT;EAAxT;AAAwT;AAAxT;EAAA,oBAAwT;EAAxT;AAAwT;AAQxT;EAAA,qEAA4E;EAA5E,4DAA4E;EAA5E,oEAA4E;EAA5E,mEAA4E;EAA5E,wDAA4E;EAA5E,oBAA4E;EAA5E,mDAA4E;EAA5E,+EAA4E;EAA5E,mGAA4E;EAA5E;AAA4E;AAW9E,0BAA0B;AAC1B;IACE,uHAAuH;EACzH;AAMA,sEAAsE;AACtE;IACE,oCAAoC;IACpC,yDAA8uI;IAC9uI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;EAC7B;AAxHF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA8RjB;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;AACA;IACE,+CAA+C;EACjD;AACA;IACE,KAAK,4BAA4B,EAAE;IACnC,OAAO,2BAA2B,EAAE;EACtC;AAaA;IACE,WAAW,YAAY,EAAE,kBAAkB,EAAE;IAC7C,MAAM,UAAU,EAAE,kBAAkB,EAAE;EACxC;AAxTF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AA2HnB;EACE,kBAAkB;EAClB,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD;IAEE,oCAAoC;EACtC;EACA;;;IAIE,oCAAoC;EACtC;AACF;;AAEA;EACE;aACW;AACb;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;;;;;;;;;;;EAaE,iDAAiD;EACjD,2CAA2C;EAC3C,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;EACjC,0DAAkD;EAAlD,kDAAkD;AACpD;;AAEA;;;;;;;;;;;;EAaE,iDAAiD;EACjD,2CAA2C;EAC3C,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;;;;;;;;EAQE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;;;;EAIE,yDAAyD;EACzD,2CAA2C;EAC3C,yBAAyB;EACzB,oCAAoC;AACtC;AACA;;;;;EAKE,mEAAmE;AACrE;;AAEA;;;;;EAKE,uEAAuE;EACvE,kEAAkE;EAClE,mEAAmE;AACrE;;AA9RA;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,qBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,qBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,mBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,mBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,0BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,yBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,qEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,qEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,qEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,kEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,qEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,oEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,qEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,oEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,gDAiUwC;EAjUxC,6DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,iDAiUwC;EAjUxC,4DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,6CAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,iDAiUwC;EAjUxC,4DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,mDAiUwC;EAjUxC,4DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,mDAiUwC;EAjUxC,6DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,gDAiUwC;EAjUxC,2DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,+EAiUwC;EAjUxC,mGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,6EAiUwC;EAjUxC,iGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,0CAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,gFAiUwC;EAjUxC,oGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,uCAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,iCAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,iCAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,8BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,qBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,iBAiUwC;EAjUxC,iBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,2BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,0BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,0BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,iBAiUwC;EAjUxC,iBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;IAAA;EAiUwC;AAAA;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,8BAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,2GAiUwC;EAjUxC,yGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;AAAA;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,kEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,4DAiUwC;EAjUxC,gEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,mEAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,wCAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,yCAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,yCAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,+CAiUwC;EAjUxC,6DAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,yCAiUwC;EAjUxC,uDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,wCAiUwC;EAjUxC,sDAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,uCAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,sBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA;IAAA,aAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,UAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,gBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,gBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,uBAiUwC;IAjUxC,uDAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,uBAiUwC;IAjUxC,oDAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,uBAiUwC;IAjUxC,oDAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,uBAiUwC;IAjUxC,4DAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,sBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,qBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,sBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,qBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,qBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,qBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,eAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,eAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,2BAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,0BAiUwC;IAjUxC;EAiUwC;AAAA;;AAjUxC;EAAA;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,oBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,iBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,eAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,eAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;AAAA;;AAjUxC;EAAA;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,QAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,gBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,kBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;AAAA;;AAjUxC;EAAA;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA;EAiUwC;EAjUxC;IAAA,mBAiUwC;IAjUxC;EAiUwC;EAjUxC;IAAA;EAiUwC;AAAA;;AAjUxC;EAAA;IAAA,sBAiUwC;IAjUxC,8BAiUwC;IAjUxC;EAiUwC;AAAA;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kGAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,oBAiUwC;EAjUxC;AAiUwC;;AAjUxC;EAAA,kGAiUwC;EAjUxC;AAiUwC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800&family=Great+Vibes&family=Playfair+Display:wght@400;500;600;700;800&family=Poppins:wght@300;400;500;600;700;800&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import 'react-inner-image-zoom/lib/styles.min.css';\n@layer base {\n  :root {\n    /* White / black / blue portal theme */\n    --primary-50: #eff6ff;\n    --primary-100: #dbeafe;\n    --primary-200: #bfdbfe;\n    --primary-300: #93c5fd;\n    --primary-400: #60a5fa;\n    --primary-500: #2563eb;\n    --primary-600: #1d4ed8;\n    --primary-700: #1e40af;\n    --primary-800: #1e3a8a;\n    --primary-900: #172554;\n    --primary-950: #0f172a;\n\n    --om-paper: #ffffff;\n    --om-surface: #ffffff;\n    --om-ink: #0f172a;\n    --om-ink-soft: #64748b;\n    --om-ink-faint: #94a3b8;\n    --om-accent: #2563eb;\n    \n    --gray-50: #ffffff;\n    --gray-100: #f1f5f9;\n    --gray-200: #e5e7eb;\n    --gray-300: #d1d5db;\n    --gray-400: #9ca3af;\n    --gray-500: #6b7280;\n    --gray-600: #4b5563;\n    --gray-700: #374151;\n    --gray-800: #1f2937;\n    --gray-900: #0f172a;\n    --gray-950: #020617;\n    --header-background: #ffffff;\n    --header-border: 1px solid rgba(15, 23, 42, 0.08);\n    --header-box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n    --header-avatar-shadow: 0 2px 8px rgba(37, 99, 235, 0.12);\n  }\n\n  html.dark {\n    --header-background: #0f172a;\n    --header-border: 1px solid rgba(255, 255, 255, 0.1);\n    --header-box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);\n  }\n}\n@layer components {\n  .glass-effect {\n    @apply bg-white/80 backdrop-blur-xl border border-white/20 shadow-xl;\n  }\n  \n  .gradient-bg {\n    background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  }\n  \n  .gradient-bg-secondary {\n    background: linear-gradient(135deg, #64748b 0%, #2563eb 100%);\n  }\n  \n  .gradient-bg-success {\n    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  }\n  \n  .gradient-bg-warning {\n    background: linear-gradient(135deg, #8a5a2b 0%, #c5a07a 100%);\n  }\n  \n  .card-hover {\n    @apply transition-all duration-300 hover:shadow-2xl hover:-translate-y-1;\n  }\n  \n  .btn-primary {\n    @apply bg-[#2563eb] text-white px-6 py-3 rounded-full font-semibold shadow-sm hover:bg-[#1d4ed8] transition-all duration-300;\n  }\n  \n  .btn-secondary {\n    @apply bg-[#f1f5f9] text-[#0f172a] px-6 py-3 rounded-full font-semibold shadow-sm hover:bg-[#e2e8f0] transition-all duration-300;\n  }\n  \n  .btn-success {\n    @apply bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105;\n  }\n  \n  .input-modern {\n    @apply w-full px-4 py-3 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 bg-white/50 dark:bg-slate-800/80 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 backdrop-blur-sm;\n  }\n  \n  .sidebar-item {\n    @apply flex items-center px-4 py-3 text-gray-600 rounded-xl transition-all duration-300 hover:bg-primary-50 hover:text-primary-700 hover:shadow-md;\n  }\n  \n  .sidebar-item.active {\n    @apply bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-lg;\n  }\n  \n  .stat-card {\n    @apply bg-white dark:bg-slate-900 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-slate-700 card-hover text-slate-900 dark:text-slate-100;\n  }\n  \n  .stat-card-gradient {\n    @apply bg-gradient-to-br from-white to-gray-50 dark:from-slate-900 dark:to-slate-950 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-slate-700 card-hover text-slate-900 dark:text-slate-100;\n  }\n\n  /* PhotoBook backgrounds */\n  .photobook-bg-party {\n    background: linear-gradient(135deg, rgba(250, 245, 255, 1) 0%, rgba(255, 255, 255, 1) 45%, rgba(240, 249, 255, 1) 100%);\n  }\n\n  .photobook-bg-wedding {\n    background: linear-gradient(135deg, #fff7ed 0%, #ffffff 45%, #fdf2f8 100%);\n  }\n\n  /* Wedding cover: matches provided sample (frame + florals + wreath) */\n  .photobook-bg-wedding-cover {\n    background-color: rgb(251, 247, 239);\n    background-image: url(\"data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%20600'%3E%3Crect%20width='1200'%20height='600'%20fill='rgb(251%2C247%2C239)'/%3E%3Cg%20opacity='0.22'%20fill='rgb(214%2C203%2C184)'%3E%3Ccircle%20cx='96'%20cy='86'%20r='6'/%3E%3Ccircle%20cx='170'%20cy='120'%20r='4'/%3E%3Ccircle%20cx='110'%20cy='180'%20r='5'/%3E%3Ccircle%20cx='1020'%20cy='92'%20r='6'/%3E%3Ccircle%20cx='1090'%20cy='140'%20r='4'/%3E%3Ccircle%20cx='1060'%20cy='190'%20r='5'/%3E%3Ccircle%20cx='120'%20cy='520'%20r='6'/%3E%3Ccircle%20cx='190'%20cy='480'%20r='4'/%3E%3Ccircle%20cx='1080'%20cy='520'%20r='6'/%3E%3Ccircle%20cx='1010'%20cy='490'%20r='4'/%3E%3C/g%3E%3Cpath%20d='M140%20105%20C250%2045%20370%2050%20480%20100%20C590%20150%20710%2050%20820%20100%20C930%20150%201055%2080%201060%20155%20C1070%20240%201075%20360%201055%20445%20C1035%20530%20910%20525%20810%20505%20C710%20485%20590%20560%20480%20510%20C370%20460%20245%20555%20165%20505%20C85%20455%2090%20400%20105%20325%20C120%20250%2065%20170%20140%20105%20Z'%20fill='none'%20stroke='rgb(214%2C164%2C83)'%20stroke-width='8'%20opacity='0.85'/%3E%3Cpath%20d='M152%20118%20C258%2062%20372%2066%20476%20110%20C580%20154%20712%2066%20816%20110%20C920%20154%201038%2096%201044%20158%20C1055%20242%201058%20356%201040%20440%20C1022%20524%20902%20518%20808%20500%20C714%20482%20586%20546%20482%20502%20C378%20458%20258%20542%20174%20498%20C90%20454%2098%20402%20112%20328%20C126%20254%2082%20174%20152%20118%20Z'%20fill='none'%20stroke='rgb(232%2C214%2C176)'%20stroke-width='6'%20opacity='0.9'/%3E%3Cg%20opacity='0.92'%3E%3Cg%20transform='translate(70%2C40)'%3E%3Cg%20fill='rgb(232%2C92%2C115)'%20opacity='0.9'%3E%3Ccircle%20cx='30'%20cy='30'%20r='10'/%3E%3Ccircle%20cx='52'%20cy='22'%20r='10'/%3E%3Ccircle%20cx='48'%20cy='48'%20r='10'/%3E%3Ccircle%20cx='24'%20cy='52'%20r='10'/%3E%3C/g%3E%3Ccircle%20cx='38'%20cy='38'%20r='9'%20fill='rgb(246%2C197%2C93)'/%3E%3Cpath%20d='M10%2060%20C30%2046%2050%2046%2072%2060'%20fill='none'%20stroke='rgb(93%2C121%2C100)'%20stroke-width='6'%20stroke-linecap='round'/%3E%3C/g%3E%3Cg%20transform='translate(1020%2C55)'%3E%3Cg%20fill='rgb(245%2C158%2C11)'%20opacity='0.85'%3E%3Ccircle%20cx='26'%20cy='26'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='20'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='44'%20r='10'/%3E%3Ccircle%20cx='20'%20cy='48'%20r='10'/%3E%3C/g%3E%3Ccircle%20cx='34'%20cy='34'%20r='9'%20fill='rgb(250%2C204%2C21)'/%3E%3Cpath%20d='M8%2058%20C28%2046%2048%2046%2070%2058'%20fill='none'%20stroke='rgb(93%2C121%2C100)'%20stroke-width='6'%20stroke-linecap='round'/%3E%3C/g%3E%3Cg%20transform='translate(78%2C500)'%3E%3Cg%20fill='rgb(251%2C113%2C133)'%20opacity='0.85'%3E%3Ccircle%20cx='26'%20cy='26'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='20'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='44'%20r='10'/%3E%3Ccircle%20cx='20'%20cy='48'%20r='10'/%3E%3C/g%3E%3Ccircle%20cx='34'%20cy='34'%20r='9'%20fill='rgb(246%2C197%2C93)'/%3E%3Cpath%20d='M8%2058%20C28%2046%2048%2046%2070%2058'%20fill='none'%20stroke='rgb(93%2C121%2C100)'%20stroke-width='6'%20stroke-linecap='round'/%3E%3C/g%3E%3Cg%20transform='translate(1030%2C498)'%3E%3Cg%20fill='rgb(245%2C158%2C11)'%20opacity='0.85'%3E%3Ccircle%20cx='26'%20cy='26'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='20'%20r='10'/%3E%3Ccircle%20cx='46'%20cy='44'%20r='10'/%3E%3Ccircle%20cx='20'%20cy='48'%20r='10'/%3E%3C/g%3E%3Ccircle%20cx='34'%20cy='34'%20r='9'%20fill='rgb(250%2C204%2C21)'/%3E%3Cpath%20d='M8%2058%20C28%2046%2048%2046%2070%2058'%20fill='none'%20stroke='rgb(93%2C121%2C100)'%20stroke-width='6'%20stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3Cg%20transform='translate(300%2C300)'%20opacity='0.95'%3E%3Ccircle%20cx='0'%20cy='0'%20r='120'%20fill='none'%20stroke='rgb(93%2C121%2C100)'%20stroke-width='5'/%3E%3Ccircle%20cx='0'%20cy='0'%20r='106'%20fill='none'%20stroke='rgb(232%2C214%2C176)'%20stroke-width='5'/%3E%3Cg%20opacity='0.9'%3E%3Ccircle%20cx='-80'%20cy='-10'%20r='5'%20fill='rgb(251%2C113%2C133)'/%3E%3Ccircle%20cx='-65'%20cy='22'%20r='4'%20fill='rgb(251%2C113%2C133)'/%3E%3Ccircle%20cx='-92'%20cy='18'%20r='3.5'%20fill='rgb(251%2C113%2C133)'/%3E%3Ccircle%20cx='78'%20cy='-12'%20r='5'%20fill='rgb(245%2C158%2C11)'/%3E%3Ccircle%20cx='92'%20cy='12'%20r='4'%20fill='rgb(245%2C158%2C11)'/%3E%3Ccircle%20cx='70'%20cy='18'%20r='3.5'%20fill='rgb(245%2C158%2C11)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n  }\n}\n\nbody {\n  font-style: normal;\n  margin: 0;\n  font-family: 'Outfit', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #ffffff;\n  color: #0f172a;\n  min-height: 100vh;\n}\n\n@media print {\n  /* Allow background colors/images in print/PDF */\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n  .photobook-bg-wedding-cover,\n  .photobook-bg-wedding,\n  .photobook-bg-party {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 2px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #94a3b8;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #64748b;\n}\n\n/* Autofill: keep readable text on light and dark forms */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\ntextarea:-webkit-autofill:active,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus,\nselect:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;\n  box-shadow: 0 0 0 1000px #ffffff inset !important;\n  -webkit-text-fill-color: #0f172a !important;\n  color: #0f172a !important;\n  caret-color: #0f172a !important;\n  background-color: #ffffff !important;\n  background-image: none !important;\n  transition: background-color 99999s ease-in-out 0s;\n}\n\nhtml.dark input:-webkit-autofill,\nhtml.dark input:-webkit-autofill:hover,\nhtml.dark input:-webkit-autofill:focus,\nhtml.dark input:-webkit-autofill:active,\nhtml.dark textarea:-webkit-autofill,\nhtml.dark textarea:-webkit-autofill:hover,\nhtml.dark textarea:-webkit-autofill:focus,\nhtml.dark textarea:-webkit-autofill:active,\nhtml.dark select:-webkit-autofill,\nhtml.dark select:-webkit-autofill:hover,\nhtml.dark select:-webkit-autofill:focus,\nhtml.dark select:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #121214 inset !important;\n  box-shadow: 0 0 0 1000px #121214 inset !important;\n  -webkit-text-fill-color: #ffffff !important;\n  color: #ffffff !important;\n  caret-color: #ffffff !important;\n  background-color: #121214 !important;\n  background-image: none !important;\n}\n\ninput:-internal-autofill-selected {\n  appearance: menulist-button;\n  background-image: none !important;\n  background-color: #ffffff !important;\n  color: #0f172a !important;\n  -webkit-text-fill-color: #0f172a !important;\n}\n\nhtml.dark input:-internal-autofill-selected {\n  background-color: #121214 !important;\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n}\n\n/* Icons next to autofilled fields */\ninput:-webkit-autofill ~ .text-icon,\ninput:-webkit-autofill:hover ~ .text-icon,\ninput:-webkit-autofill:focus ~ .text-icon,\ninput:-webkit-autofill:active ~ .text-icon,\ninput:-webkit-autofill + .text-icon,\ninput:-webkit-autofill:hover + .text-icon,\ninput:-webkit-autofill:focus + .text-icon,\ninput:-webkit-autofill:active + .text-icon {\n  color: #64748b !important;\n  opacity: 1 !important;\n  filter: none !important;\n}\n\nhtml.dark input:-webkit-autofill ~ .text-icon,\nhtml.dark input:-webkit-autofill:hover ~ .text-icon,\nhtml.dark input:-webkit-autofill:focus ~ .text-icon,\nhtml.dark input:-webkit-autofill:active ~ .text-icon,\nhtml.dark input:-webkit-autofill + .text-icon,\nhtml.dark input:-webkit-autofill:hover + .text-icon,\nhtml.dark input:-webkit-autofill:focus + .text-icon,\nhtml.dark input:-webkit-autofill:active + .text-icon {\n  color: #94a3b8 !important;\n}\n\n/* Override autofill white text for light-background forms (invitations, etc.) */\n.bg-white input:-webkit-autofill,\n.bg-white input:-webkit-autofill:hover,\n.bg-white input:-webkit-autofill:focus,\n.bg-white input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;\n  -webkit-text-fill-color: #0f172a !important;\n  color: #0f172a !important;\n  background-color: #ffffff !important;\n}\n.to-purple-600,\n.to-violet-600,\n.to-indigo-600,\n.to-blue-600,\n.to-fuchsia-600 {\n  --tw-gradient-to: #2563eb var(--tw-gradient-to-position) !important;\n}\n\n.from-purple-600,\n.from-violet-600,\n.from-indigo-600,\n.from-blue-600,\n.from-fuchsia-600 {\n  --tw-gradient-from: #0f172a var(--tw-gradient-from-position) !important;\n  --tw-gradient-to: rgb(20 18 16 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n@layer utilities {\n  @keyframes cover-fade-in {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  .cover-fade-in {\n    animation: cover-fade-in 0.5s ease-out forwards;\n  }\n  @keyframes loader-shimmer {\n    0% { background-position: -120% 0; }\n    100% { background-position: 220% 0; }\n  }\n  .loader-shimmer {\n    background: linear-gradient(\n      90deg,\n      rgba(34, 211, 238, 0) 0%,\n      rgba(34, 211, 238, 0.4) 45%,\n      rgba(34, 211, 238, 0.8) 50%,\n      rgba(34, 211, 238, 0.4) 55%,\n      rgba(34, 211, 238, 0) 100%\n    );\n    background-size: 200% 100%;\n    animation: loader-shimmer 1.8s ease-in-out infinite;\n  }\n  @keyframes loader-glow {\n    0%, 100% { opacity: 0.6; filter: blur(12px); }\n    50% { opacity: 1; filter: blur(16px); }\n  }\n  .loader-glow-pulse {\n    animation: loader-glow 2s ease-in-out infinite;\n  }\n}\n\n@import './styles/app-portal-pages.css';"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
